var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// @ts-nocheck
function $394b8360f422ee65$export$ff5f2eeb11fc7e14() {
    if (typeof globalThis !== "undefined") return globalThis;
    else if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else if (typeof $parcel$global !== "undefined") return $parcel$global;
}
if (typeof globalThis === "undefined") globalThis = $394b8360f422ee65$export$ff5f2eeb11fc7e14();


// @ts-nocheck
const $06f1f99db166e4ee$var$root = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof $parcel$global !== "undefined" && $parcel$global;
function $06f1f99db166e4ee$var$isConstructor(fn) {
    try {
        new fn("");
    } catch (error) {
        return false;
    }
    return true;
}
if (typeof $06f1f99db166e4ee$var$root.Event !== "function" || !$06f1f99db166e4ee$var$isConstructor($06f1f99db166e4ee$var$root.Event)) $06f1f99db166e4ee$var$root.Event = function() {
    function Event1(type, options) {
        this.bubbles = !!options && !!options.bubbles;
        this.cancelable = !!options && !!options.cancelable;
        this.composed = !!options && !!options.composed;
        this.type = type;
    }
    return Event1;
}();
if (typeof $06f1f99db166e4ee$var$root.EventTarget === "undefined" || !$06f1f99db166e4ee$var$isConstructor($06f1f99db166e4ee$var$root.EventTarget)) $06f1f99db166e4ee$var$root.EventTarget = function() {
    function EventTarget() {
        this.__listeners = new Map();
    }
    EventTarget.prototype = Object.create(Object.prototype);
    EventTarget.prototype.addEventListener = function(type, listener, options) {
        if (arguments.length < 2) throw new TypeError(`TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`);
        const __listeners = this.__listeners;
        const actualType = type.toString();
        if (!__listeners.has(actualType)) __listeners.set(actualType, new Map());
        const listenersForType = __listeners.get(actualType);
        if (!listenersForType.has(listener)) // Any given listener is only registered once
        listenersForType.set(listener, options);
    };
    EventTarget.prototype.removeEventListener = function(type, listener, _options) {
        if (arguments.length < 2) throw new TypeError(`TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`);
        const __listeners = this.__listeners;
        const actualType = type.toString();
        if (__listeners.has(actualType)) {
            const listenersForType = __listeners.get(actualType);
            if (listenersForType.has(listener)) listenersForType.delete(listener);
        }
    };
    EventTarget.prototype.dispatchEvent = function(event) {
        if (!(event instanceof Event)) throw new TypeError(`Failed to execute 'dispatchEvent' on 'EventTarget': parameter 1 is not of type 'Event'.`);
        const type = event.type;
        const __listeners = this.__listeners;
        const listenersForType = __listeners.get(type);
        if (listenersForType) for (const [listener, options] of listenersForType.entries()){
            try {
                if (typeof listener === "function") listener.call(this, event);
                else if (listener && typeof listener.handleEvent === "function") listener.handleEvent(event);
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            if (options && options.once) // If this was registered with { once: true }, we need
            // to remove it now.
            listenersForType.delete(listener);
        }
        return true;
    };
    return EventTarget;
}();


// @ts-nocheck
class $3cfe36083fdf784d$var$Emitter {
    constructor(){
        Object.defineProperty(this, "listeners", {
            value: {},
            writable: true,
            configurable: true
        });
    }
    addEventListener(type, callback, options) {
        if (!(type in this.listeners)) this.listeners[type] = [];
        this.listeners[type].push({
            callback: callback,
            options: options
        });
    }
    removeEventListener(type, callback) {
        if (!(type in this.listeners)) return;
        const stack = this.listeners[type];
        for(let i = 0, l = stack.length; i < l; i++)if (stack[i].callback === callback) {
            stack.splice(i, 1);
            return;
        }
    }
    dispatchEvent(event) {
        if (!(event.type in this.listeners)) return;
        const stack = this.listeners[event.type];
        const stackToCall = stack.slice();
        for(let i = 0, l = stackToCall.length; i < l; i++){
            const listener = stackToCall[i];
            try {
                listener.callback.call(this, event);
            } catch (e) {
                Promise.resolve().then(()=>{
                    throw e;
                });
            }
            if (listener.options && listener.options.once) this.removeEventListener(event.type, listener.callback);
        }
        return !event.defaultPrevented;
    }
}
class $3cfe36083fdf784d$export$e42c54032314dc1d extends $3cfe36083fdf784d$var$Emitter {
    constructor(){
        super();
        if (!this.listeners) $3cfe36083fdf784d$var$Emitter.call(this);
        Object.defineProperty(this, "aborted", {
            value: false,
            writable: true,
            configurable: true
        });
        Object.defineProperty(this, "onabort", {
            value: null,
            writable: true,
            configurable: true
        });
        Object.defineProperty(this, "reason", {
            value: undefined,
            writable: true,
            configurable: true
        });
    }
    toString() {
        return "[object AbortSignal]";
    }
    dispatchEvent(event) {
        if (event.type === "abort") {
            this.aborted = true;
            if (typeof this.onabort === "function") this.onabort.call(this, event);
        }
        super.dispatchEvent(event);
    }
}
class $3cfe36083fdf784d$export$48f7e099c149af88 {
    constructor(){
        Object.defineProperty(this, "signal", {
            value: new $3cfe36083fdf784d$export$e42c54032314dc1d(),
            writable: true,
            configurable: true
        });
    }
    abort(reason) {
        let event;
        event = new Event("abort");
        let signalReason = reason;
        if (signalReason === undefined) {
            signalReason = new Error("This operation was aborted");
            signalReason.name = "AbortError";
        }
        this.signal.reason = signalReason;
        this.signal.dispatchEvent(event);
    }
    toString() {
        return "[object AbortController]";
    }
}
function $3cfe36083fdf784d$var$polyfillNeeded(self1) {
    return typeof self1.Request === "function" && !self1.Request.prototype.hasOwnProperty("signal") || !self1.AbortController;
}
(function(self1) {
    "use strict";
    if (!$3cfe36083fdf784d$var$polyfillNeeded(self1)) return;
    if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        $3cfe36083fdf784d$export$48f7e099c149af88.prototype[Symbol.toStringTag] = "AbortController";
        $3cfe36083fdf784d$export$e42c54032314dc1d.prototype[Symbol.toStringTag] = "AbortSignal";
    }
    self1.AbortController = $3cfe36083fdf784d$export$48f7e099c149af88;
    self1.AbortSignal = $3cfe36083fdf784d$export$e42c54032314dc1d;
})(typeof self !== "undefined" ? self : $parcel$global);



const $a14956b79f4c32ef$var$global = (0, $394b8360f422ee65$export$ff5f2eeb11fc7e14)();
if (typeof $a14956b79f4c32ef$var$global.queueMicrotask !== "function") $a14956b79f4c32ef$var$global.queueMicrotask = function(callback) {
    Promise.resolve().then(callback).catch((e)=>setTimeout(()=>{
            throw e;
        }));
};


// @ts-nocheck
if (!Array.prototype.flat) Object.defineProperty(Array.prototype, "flat", {
    configurable: true,
    value: function flat() {
        const depth = isNaN(arguments[0]) ? 1 : Number(arguments[0]);
        return depth ? Array.prototype.reduce.call(this, function(acc, cur) {
            if (Array.isArray(cur)) acc.push.apply(acc, flat.call(cur, depth - 1));
            else acc.push(cur);
            return acc;
        }, []) : Array.prototype.slice.call(this);
    },
    writable: true
});
if (!Array.prototype.flatMap) Object.defineProperty(Array.prototype, "flatMap", {
    configurable: true,
    value: function flatMap(callback) {
        return Array.prototype.map.apply(this, arguments).flat();
    },
    writable: true
});




var $8836d3b72d09aae5$export$5de0c2f48b03ac5c;
(function(EVideoControllerCustomEvent) {
    EVideoControllerCustomEvent["CLICK"] = "videoElement.click";
    EVideoControllerCustomEvent["PLAYING"] = "videoElement.playing";
    EVideoControllerCustomEvent["LOADING"] = "videoElement.loading";
    EVideoControllerCustomEvent["PAUSE"] = "videoElement.pause";
    EVideoControllerCustomEvent["VIDEO_PLAYBACK_STATE_CHANGE"] = "videoElement.videoPlaybackStateChange";
    EVideoControllerCustomEvent["NATIVE_EVENT"] = "videoElement.nativeEvent";
    EVideoControllerCustomEvent["UPDATE_PLAYER_RESOLUTION"] = "videoElement.updatePlayerResolution";
    EVideoControllerCustomEvent["TIME_UPDATE"] = "videoElement.timeUpdate";
})($8836d3b72d09aae5$export$5de0c2f48b03ac5c || ($8836d3b72d09aae5$export$5de0c2f48b03ac5c = {}));


class $ae21521d6337de01$export$5087227eb54526 {
    constructor(immediateExceptions = true){
        this.appId = null;
        this._lastUid = -1;
        this._messages = {};
        this._immediateExceptions = false;
        this._allSubscribingMsg = "*";
        this._immediateExceptions = immediateExceptions;
    }
    setAppId(id) {
        this.appId = id;
    }
    getAppId() {
        return this.appId;
    }
    publish(event, data) {
        return this._publish(event, data, false, this._immediateExceptions);
    }
    publishSync(event, data) {
        return this._publish(event, data, true, this._immediateExceptions);
    }
    subscribe(event, callback) {
        if (typeof callback !== "function") return "";
        const token = "uid_" + String(++this._lastUid);
        if (!this._messages[event]) this._messages[event] = {};
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const d = this._messages[event] || {};
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        d[token] = callback;
        // return token for unsubscribing
        return token;
    }
    toggleSubscriptionBulk(data) {
        if (data.action === "subscribe") Object.entries(data.callbacks).forEach(([key, cb])=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.subscribe.call(this, key, cb);
        });
        else // eslint-disable-next-line no-unused-vars
        Object.entries(data.callbacks).forEach(([_key, cb])=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.unsubscribe.call(this, cb);
        });
    }
    subscribeAll(callback) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.subscribe(this._allSubscribingMsg, callback);
    }
    subscribeOnce(event, callback) {
        const token = this.subscribe(event, (...args)=>{
            // before func apply, unsubscribe message
            this.unsubscribe(token);
            callback.apply(this, args);
        });
        return this;
    }
    clearAllSubscriptions() {
        this._messages = {};
    }
    clearSubscriptions(topic) {
        for(const m in this._messages)if (Object.prototype.hasOwnProperty.call(this._messages, m) && m.indexOf(topic) === 0) delete this._messages[m];
    }
    unsubscribe(value) {
        const isTopic = typeof value === "string" && (Object.prototype.hasOwnProperty.call(this._messages, value) || this._descendantTopicExists(value));
        const isToken = !isTopic && typeof value === "string";
        const isFunction = typeof value === "function";
        let result = false;
        if (isTopic) {
            this.clearSubscriptions(value);
            return;
        }
        for(const m in this._messages)if (Object.prototype.hasOwnProperty.call(this._messages, m)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const message = this._messages[m] || {};
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (isToken && message[value]) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                delete message[value];
                result = value;
                break;
            }
            if (isFunction) {
                for(const t in message)if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value) {
                    delete message[t];
                    result = true;
                }
            }
        }
        return result;
    }
    _hasKeys(obj) {
        for(const key in obj){
            if (Object.prototype.hasOwnProperty.call(obj, key)) return true;
        }
        return false;
    }
    _throwException(e) {
        return ()=>{
            throw e;
        };
    }
    _callSubscriberWithDelayedExceptions(subscriber, data) {
        try {
            subscriber(data);
        } catch (ex) {
            setTimeout(this._throwException(ex), 0);
        }
    }
    _callSubscriberWithImmediateExceptions(subscriber, data) {
        subscriber(data);
    }
    _deliverMessage(originalMessage, matchedMessage, data, immediateExceptions) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const subscribers = this._messages[matchedMessage] || {};
        const callSubscriber = immediateExceptions ? this._callSubscriberWithImmediateExceptions : this._callSubscriberWithDelayedExceptions;
        if (!Object.prototype.hasOwnProperty.call(this._messages, matchedMessage)) return;
        for(const s in subscribers)if (Object.prototype.hasOwnProperty.call(subscribers, s)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        callSubscriber(subscribers[s], data);
    }
    _createDeliveryFunction(event, data, immediateExceptions) {
        return ()=>{
            let topic = String(event);
            let position = topic.lastIndexOf(".");
            this._deliverMessage(event, event, data, immediateExceptions);
            while(position > -1){
                topic = topic.substr(0, position);
                position = topic.lastIndexOf(".");
                this._deliverMessage(event, topic, data, immediateExceptions);
            }
            this._deliverMessage(event, this._allSubscribingMsg, data, immediateExceptions);
        };
    }
    _hasDirectSubscribersFor(message) {
        const topic = String(message);
        return Boolean(Object.prototype.hasOwnProperty.call(this._messages, topic) && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this._hasKeys(this._messages[topic] || {}));
    }
    _messageHasSubscribers(message) {
        let topic = String(message);
        let found = this._hasDirectSubscribersFor(topic) || this._hasDirectSubscribersFor(this._allSubscribingMsg);
        let position = topic.lastIndexOf(".");
        while(!found && position !== -1){
            topic = topic.substr(0, position);
            position = topic.lastIndexOf(".");
            found = this._hasDirectSubscribersFor(topic);
        }
        return found;
    }
    _publish(message, data, sync, immediateExceptions) {
        const normalizedMessage = typeof message === "symbol" ? message.toString() : message;
        const deliver = this._createDeliveryFunction(normalizedMessage, data, immediateExceptions);
        const hasSubscribers = this._messageHasSubscribers(normalizedMessage);
        if (!hasSubscribers) return false;
        if (sync) deliver();
        else setTimeout(deliver, 0);
        return true;
    }
    _descendantTopicExists(topic) {
        for(const m in this._messages){
            if (Object.prototype.hasOwnProperty.call(this._messages, m) && m.indexOf(topic) === 0) return true;
        }
        return false;
    }
}
const $ae21521d6337de01$var$eventBusInstance = new $ae21521d6337de01$export$5087227eb54526();
var $ae21521d6337de01$export$2e2bcd8739ae039 = $ae21521d6337de01$var$eventBusInstance;



const $0f507525d59ab7a9$export$5087227eb54526 = new (0, $ae21521d6337de01$export$5087227eb54526)();
const $0f507525d59ab7a9$export$543824cd4593e990 = {
    configUpdated: "configProvider.configUpdated"
};
const $0f507525d59ab7a9$export$5dfe6d416f9f0f4a = (key)=>`${$0f507525d59ab7a9$export$543824cd4593e990.configUpdated}.${key}`;


const $deb5779b808f730b$export$6424a9a81c99aaba = (fallbackEventBus)=>{
    let globalConfig = {};
    const configConsumerConstructor = class ConfigConsumer {
        constructor(originalClassName, eventBus){
            this._onConfigUpdatedWithContext = this._onConfigUpdated.bind(this);
            this._configKey = originalClassName;
            this._eventBus = eventBus || fallbackEventBus;
            const correspondingSubscriptionName = (0, $0f507525d59ab7a9$export$5dfe6d416f9f0f4a)(originalClassName);
            this._onConfigUpdatedListener = this._eventBus.subscribe(correspondingSubscriptionName, this._onConfigUpdatedWithContext);
            this.config = globalConfig[originalClassName];
        }
        destroy() {
            this._eventBus.unsubscribe(this._onConfigUpdatedListener);
        }
        _handleConfigUpdated(_updatedValues, _newConfig) {}
        _onConfigUpdated(data) {
            globalConfig = data.newConfig;
            const newCurrentConfig = data.newConfig[this._configKey];
            this.config = newCurrentConfig;
            this._handleConfigUpdated(data.updatedValues, newCurrentConfig);
        }
    };
    const setConsumerConfig = (config)=>{
        globalConfig = config;
    };
    return {
        configConsumerConstructor: configConsumerConstructor,
        setConsumerConfig: setConsumerConfig
    };
};



// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $04a3ee20018aad1e$export$871608497c498473 = (d)=>d instanceof Date;
const $04a3ee20018aad1e$export$1b3bfaa9684536aa = (d)=>d instanceof Element || d instanceof Document;
const $04a3ee20018aad1e$export$dd1bc94b04021eeb = (o)=>Object.keys(o).length === 0;
const $04a3ee20018aad1e$export$a6cdc56e425d0d0a = (o)=>o != null && typeof o === "object";
const $04a3ee20018aad1e$export$5a15a386532a5ea4 = (o, ...args)=>// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    Object.prototype.hasOwnProperty.call(o, ...args);
const $04a3ee20018aad1e$export$83b788b1a3698c03 = (o)=>$04a3ee20018aad1e$export$a6cdc56e425d0d0a(o) && $04a3ee20018aad1e$export$dd1bc94b04021eeb(o);
const $04a3ee20018aad1e$export$1d1d2ed6b55cf67f = (fn)=>(args)=>new Promise((resolve, reject)=>{
            fn(args, (callbackArgs)=>{
                resolve(callbackArgs);
            }, (err)=>{
                reject(err);
            });
        });


const $4053fea44be815ab$export$925cb066f75a1c3e = (lhs, rhs)=>{
    if (lhs === rhs) return {}; // equal return no diff
    if (!(0, $04a3ee20018aad1e$export$a6cdc56e425d0d0a)(lhs) || !(0, $04a3ee20018aad1e$export$a6cdc56e425d0d0a)(rhs) || (0, $04a3ee20018aad1e$export$1b3bfaa9684536aa)(lhs) || (0, $04a3ee20018aad1e$export$1b3bfaa9684536aa)(rhs)) return rhs; // return updated rhs
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const l = lhs;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const r = rhs;
    const deletedValues = Object.keys(l).reduce((acc, key)=>{
        if (!(0, $04a3ee20018aad1e$export$5a15a386532a5ea4)(r, key)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        acc[key] = undefined;
        return acc;
    }, {});
    if ((0, $04a3ee20018aad1e$export$871608497c498473)(l) || (0, $04a3ee20018aad1e$export$871608497c498473)(r)) {
        if (l.valueOf() == r.valueOf()) return {};
        return r;
    }
    return Object.keys(r).reduce((acc, key)=>{
        if (!(0, $04a3ee20018aad1e$export$5a15a386532a5ea4)(l, key)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            acc[key] = r[key]; // return added r key
            return acc;
        }
        const difference = $4053fea44be815ab$export$925cb066f75a1c3e(l[key], r[key]);
        // If the difference is empty, and the lhs is an empty object or the rhs is not an empty object
        if ((0, $04a3ee20018aad1e$export$83b788b1a3698c03)(difference) && !(0, $04a3ee20018aad1e$export$871608497c498473)(difference) && ((0, $04a3ee20018aad1e$export$83b788b1a3698c03)(l[key]) || !(0, $04a3ee20018aad1e$export$83b788b1a3698c03)(r[key]))) return acc; // return no diff
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        acc[key] = difference; // return updated key
        return acc; // return updated key
    }, deletedValues);
};


const $04d1fdac2b95d887$export$45a69314cf48a3eb = (defaultConfig)=>{
    let config = {
        ...defaultConfig
    };
    const _fallbackEventBus = new (0, $ae21521d6337de01$export$5087227eb54526)();
    const { configConsumerConstructor: configConsumerConstructor , setConsumerConfig: setConsumerConfig  } = (0, $deb5779b808f730b$export$6424a9a81c99aaba)(_fallbackEventBus);
    setConsumerConfig(defaultConfig);
    const getConfigField = (configKey)=>config[configKey];
    const getConfig = ()=>config;
    const setConfig = (newConfig, eventBus, sync = false)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const mergedConfig = Object.entries(newConfig).reduce((oldConfig, [newConfigKey, newConfigValues])=>{
            oldConfig[newConfigKey] = {
                ...oldConfig[newConfigKey],
                ...newConfigValues
            };
            return oldConfig;
        }, {
            ...config
        });
        const diff = (0, $4053fea44be815ab$export$925cb066f75a1c3e)(config, mergedConfig);
        config = mergedConfig;
        Object.entries(diff).forEach(([key, value])=>{
            const eventName = (0, $0f507525d59ab7a9$export$5dfe6d416f9f0f4a)(key);
            if (sync) eventBus.publishSync(eventName, {
                updatedValues: value,
                newConfig: mergedConfig
            });
            else eventBus.publish(eventName, {
                updatedValues: value,
                newConfig: mergedConfig
            });
        });
        setConsumerConfig(config);
    };
    const resetConfig = ()=>{
        config = {
            ...defaultConfig
        };
    };
    return {
        getConfigField: getConfigField,
        setConfig: setConfig,
        getConfig: getConfig,
        resetConfig: resetConfig,
        ConfigConsumer: configConsumerConstructor
    };
};


function $5fb98e84471f1647$export$2385a24977818dd0(// eslint-disable-next-line @typescript-eslint/ban-types
_target, propertyKey, descriptor) {
    if (!descriptor || typeof descriptor.value !== "function") throw new TypeError(`Only methods can be decorated with @bind. <${propertyKey}> is not a method!`);
    return {
        configurable: true,
        get () {
            const bound = descriptor.value?.bind(this);
            // Credits to https://github.com/andreypopp/autobind-decorator for memoizing the result of bind against a symbol on the instance.
            Object.defineProperty(this, propertyKey, {
                value: bound,
                configurable: true,
                writable: true
            });
            return bound;
        }
    };
}


var $2b02fdf3c00e51bd$export$41789205b2aea69e;
(function(EPlayerType) {
    EPlayerType["HLS"] = "hls";
    EPlayerType["WEBRTC"] = "webrtc";
    EPlayerType["NATIVE"] = "native";
    EPlayerType["BROADCAST"] = "broadcast";
})($2b02fdf3c00e51bd$export$41789205b2aea69e || ($2b02fdf3c00e51bd$export$41789205b2aea69e = {}));
var $2b02fdf3c00e51bd$export$af29ccb356acd9fc;
(function(EPlaybackState) {
    EPlaybackState["IDLE"] = "idle";
    EPlaybackState["LOADING"] = "loading";
    EPlaybackState["PAUSED"] = "paused";
    EPlaybackState["PLAYING"] = "playing";
    EPlaybackState["ERROR"] = "error";
})($2b02fdf3c00e51bd$export$af29ccb356acd9fc || ($2b02fdf3c00e51bd$export$af29ccb356acd9fc = {}));
var $2b02fdf3c00e51bd$export$fadb1eea8aff454b;
(function(EPlaybackStartType) {
    EPlaybackStartType["WAITING"] = "waiting";
    EPlaybackStartType["AUTO"] = "auto";
    EPlaybackStartType["MANUAL"] = "manual";
})($2b02fdf3c00e51bd$export$fadb1eea8aff454b || ($2b02fdf3c00e51bd$export$fadb1eea8aff454b = {}));
var $2b02fdf3c00e51bd$export$f04e9ce1ec2bc9bf;
(function(ECommonEvent) {
    ECommonEvent["BROADCAST_STATE_CHANGED"] = "commonEvents.broadcastStateChanged";
    ECommonEvent["BROADCAST_REMOTE_STATS_AVAILABLE"] = "commonEvents.broadcastRemoteStatsAvailable";
    ECommonEvent["PLAYING_STATE_CHANGED"] = "commonEvents.playingStateChanged";
    ECommonEvent["COMMON_ERROR"] = "commonEvents.commonError";
})($2b02fdf3c00e51bd$export$f04e9ce1ec2bc9bf || ($2b02fdf3c00e51bd$export$f04e9ce1ec2bc9bf = {}));


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $857b03fc78e933b4$var$extendStatics = function(d, b) {
    $857b03fc78e933b4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $857b03fc78e933b4$var$extendStatics(d, b);
};
function $857b03fc78e933b4$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $857b03fc78e933b4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $857b03fc78e933b4$export$18ce0697a983be9b = function() {
    $857b03fc78e933b4$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $857b03fc78e933b4$export$18ce0697a983be9b.apply(this, arguments);
};
function $857b03fc78e933b4$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $857b03fc78e933b4$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $857b03fc78e933b4$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $857b03fc78e933b4$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $857b03fc78e933b4$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $857b03fc78e933b4$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $857b03fc78e933b4$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $857b03fc78e933b4$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $857b03fc78e933b4$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $857b03fc78e933b4$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $857b03fc78e933b4$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $857b03fc78e933b4$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $857b03fc78e933b4$export$45d3717a4c69092e(o, m, p);
}
function $857b03fc78e933b4$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $857b03fc78e933b4$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $857b03fc78e933b4$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($857b03fc78e933b4$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $857b03fc78e933b4$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $857b03fc78e933b4$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $857b03fc78e933b4$export$10c90e4f7922046c(v) {
    return this instanceof $857b03fc78e933b4$export$10c90e4f7922046c ? (this.v = v, this) : new $857b03fc78e933b4$export$10c90e4f7922046c(v);
}
function $857b03fc78e933b4$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $857b03fc78e933b4$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $857b03fc78e933b4$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $857b03fc78e933b4$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $857b03fc78e933b4$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $857b03fc78e933b4$export$19a8beecd37a4c45 === "function" ? $857b03fc78e933b4$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $857b03fc78e933b4$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $857b03fc78e933b4$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $857b03fc78e933b4$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $857b03fc78e933b4$export$45d3717a4c69092e(result, mod, k);
    }
    $857b03fc78e933b4$var$__setModuleDefault(result, mod);
    return result;
}
function $857b03fc78e933b4$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $857b03fc78e933b4$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $857b03fc78e933b4$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $857b03fc78e933b4$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}






const $94461adbdb46cca1$export$5087227eb54526 = new (0, $ae21521d6337de01$export$5087227eb54526)();
var $94461adbdb46cca1$export$7999b4a47f0af35e;
(function(ELoggerEvents) {
    ELoggerEvents["LOG"] = "logger.log";
})($94461adbdb46cca1$export$7999b4a47f0af35e || ($94461adbdb46cca1$export$7999b4a47f0af35e = {}));


const $59dc5ffc15ec8449$var$abstractLogger = (eventBus, domain, level)=>(message, payload)=>{
        eventBus.publish((0, $94461adbdb46cca1$export$7999b4a47f0af35e).LOG, {
            domain: domain,
            timestamp: performance.now(),
            level: level,
            message: message,
            payload: payload
        });
    };
const $59dc5ffc15ec8449$export$efa9a398d6368992 = (eventBus, rawDomain)=>{
    const domain = `${rawDomain}{${(Math.random() + 1).toString(36).substring(2, 6)}}`;
    return {
        debug: $59dc5ffc15ec8449$var$abstractLogger(eventBus, domain, "debug"),
        verbose: $59dc5ffc15ec8449$var$abstractLogger(eventBus, domain, "verbose"),
        info: $59dc5ffc15ec8449$var$abstractLogger(eventBus, domain, "info"),
        warn: $59dc5ffc15ec8449$var$abstractLogger(eventBus, domain, "warn"),
        error: $59dc5ffc15ec8449$var$abstractLogger(eventBus, domain, "error"),
        fatal: $59dc5ffc15ec8449$var$abstractLogger(eventBus, domain, "fatal")
    };
};





const $208fa258ff142390$export$cc28b71b38e9701d = (...msgs)=>// eslint-disable-next-line no-console
    console.log(...msgs.filter((item)=>item !== undefined));




const $6b88f92c0e0219d7$var$logLevelToMsg = {
    debug: (msg, payload)=>(0, $208fa258ff142390$export$cc28b71b38e9701d)(`%c${msg}`, "color: rgb(102, 102, 102)", payload),
    verbose: (msg, payload)=>(0, $208fa258ff142390$export$cc28b71b38e9701d)(`%c${msg}`, "color: rgb(36, 114, 200)", payload),
    info: (msg, payload)=>(0, $208fa258ff142390$export$cc28b71b38e9701d)(`%c${msg}`, "color: rgb(13, 188, 121)", payload),
    warn: (msg, payload)=>(0, $208fa258ff142390$export$cc28b71b38e9701d)(`%c${msg}`, "color: rgb(229, 229, 16)", payload),
    error: (msg, payload)=>(0, $208fa258ff142390$export$cc28b71b38e9701d)(`%c${msg}`, "color: rgb(241, 76, 76)", payload),
    fatal: (msg, payload)=>(0, $208fa258ff142390$export$cc28b71b38e9701d)(`%c${msg}`, "background: rgb(241, 76, 76); color: #fff", payload)
};
const $6b88f92c0e0219d7$var$defaultLevels = [];
class $6b88f92c0e0219d7$export$8734a8c908553955 {
    constructor(eventBus, levels = $6b88f92c0e0219d7$var$defaultLevels, additionalScopes = [], ignoreDomains = [], enableErrorAutoLog = true){
        this._levels = levels;
        this._eventBus = eventBus;
        this._enableErrorAutoLog = enableErrorAutoLog;
        this._onLogMessageReceivedToken = this._eventBus.subscribe((0, $94461adbdb46cca1$export$7999b4a47f0af35e).LOG, this._onMessageReceived);
        this._onErrorReceivedToken = this._eventBus.subscribe((0, $2b02fdf3c00e51bd$export$f04e9ce1ec2bc9bf).COMMON_ERROR, this._onErrorReceived);
        this._ignoreDomains = ignoreDomains;
        this._additionalScopeSubscriptions = additionalScopes.map((additionalScope)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line @streaming/eventbus/noUnsavedSubscribers
            return this._eventBus.subscribe(additionalScope, (payload)=>{
                this._onAdditionalScopeMessageReceived(additionalScope, payload);
            });
        });
        this._appId = `${(Math.random() + 1).toString(36).substring(2, 6)}`;
    }
    destroy() {
        this._eventBus.unsubscribe(this._onLogMessageReceivedToken);
        this._eventBus.unsubscribe(this._onErrorReceivedToken);
        this._additionalScopeSubscriptions.forEach(this._eventBus.unsubscribe);
    }
    _onMessageReceived(data) {
        const { domain: domain , timestamp: timestamp , level: level , message: message , payload: payload  } = data;
        if (!this._levels.includes(level) || this._ignoreDomains.includes(domain)) return;
        const levelLogger = $6b88f92c0e0219d7$var$logLevelToMsg[level] || $6b88f92c0e0219d7$var$logLevelToMsg["info"];
        levelLogger(`(${this._appId}) :: [${domain}] ${level.toUpperCase()}:\n${message}@${timestamp}`, payload);
    }
    _onAdditionalScopeMessageReceived(scope, payload) {
        const levelLogger = $6b88f92c0e0219d7$var$logLevelToMsg["verbose"];
        levelLogger(`[${scope}] Event receiver with payload ${payload} @ ${performance.now()}`);
    }
    _onErrorReceived({ error: error  }) {
        if (this._enableErrorAutoLog) (0, $59dc5ffc15ec8449$export$efa9a398d6368992)(this._eventBus, "COMMON ERROR").error(`Error in ${error.domain}: ${error.message} ${error.info && " (" + error.info + ")"}`);
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $6b88f92c0e0219d7$export$8734a8c908553955.prototype, "_onMessageReceived", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $6b88f92c0e0219d7$export$8734a8c908553955.prototype, "_onAdditionalScopeMessageReceived", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $6b88f92c0e0219d7$export$8734a8c908553955.prototype, "_onErrorReceived", null);



const $a99bfb4a2e753607$export$1d295a4981f9ea1e = {
    videoElementControllerConfig: {
        limitCheckingAutoplay: 5,
        minimalPossibleVideoDimension: 50,
        timeoutUpdateStatusPlaying: 2000,
        timeoutUpdateVideoDuration: 500
    }
};
const { ConfigConsumer: $a99bfb4a2e753607$export$cd5442f2b8da7663 , setConfig: $a99bfb4a2e753607$export$940a7873bb071df8 , resetConfig: $a99bfb4a2e753607$export$bc1df4f51648e58e  } = (0, $04d1fdac2b95d887$export$45a69314cf48a3eb)($a99bfb4a2e753607$export$1d295a4981f9ea1e);



var $de1faff85a9c2843$export$60e3c1025821af4f;
(function(EVideoElementControllerBusEvent) {
    EVideoElementControllerBusEvent["NATIVE_EVENT"] = "videoElementController.nativeEvent";
    EVideoElementControllerBusEvent["CLICK"] = "videoElementController.click";
    EVideoElementControllerBusEvent["FORCE_PLAY_AFTER_PAUSE"] = "videoElementController.forcePlayAfterPause";
    EVideoElementControllerBusEvent["VIDEO_START"] = "videoElementController.videoStart";
    EVideoElementControllerBusEvent["VIDEO_PAUSE"] = "videoElementController.videoPause";
    EVideoElementControllerBusEvent["VIDEO_RESET"] = "videoElementController.videoReset";
    EVideoElementControllerBusEvent["PAUSED"] = "videoElementController.paused";
    EVideoElementControllerBusEvent["PLAYING"] = "videoElementController.playing";
    EVideoElementControllerBusEvent["LOADING"] = "videoElementController.loading";
    EVideoElementControllerBusEvent["LOADED"] = "videoElementController.loaded";
    EVideoElementControllerBusEvent["UPDATED"] = "videoElementController.updated";
    EVideoElementControllerBusEvent["DESTROY"] = "videoElementController.destroy";
    EVideoElementControllerBusEvent["STREAM_RESET"] = "videoElementController.streamReset";
    EVideoElementControllerBusEvent["CAN_PLAY"] = "videoElementController.canPlay";
    EVideoElementControllerBusEvent["REMOVE_MEDIA_STREAM"] = "videoElementController.removeMediaStream";
    EVideoElementControllerBusEvent["ERROR"] = "videoElementController.error";
    EVideoElementControllerBusEvent["ABORT"] = "videoElementController.abort";
    EVideoElementControllerBusEvent["STALLED"] = "videoElementController.stalled";
    EVideoElementControllerBusEvent["WAITING"] = "videoElementController.waiting";
    EVideoElementControllerBusEvent["UPDATE_PLAYER_RESOLUTION"] = "videoElementController.updatePlayerResolution";
    EVideoElementControllerBusEvent["RESET_CHECKING_AUTOPLAY_COUNT"] = "videoElementController.resetCheckingAutoplayCount";
    EVideoElementControllerBusEvent["CANCEL_RESET_STREAM"] = "videoElementController.cancelResetStream";
    EVideoElementControllerBusEvent["RESTART"] = "videoElementController.restart";
    EVideoElementControllerBusEvent["TIME_UPDATE_NATIVE"] = "videoElementController.native";
    EVideoElementControllerBusEvent["UPDATE_MEDIA_STREAM"] = "videoElementController.updateMediaStream";
    EVideoElementControllerBusEvent["VIDEO_ELEMENT_RECREATED"] = "videoElementController.videoElementRecreated";
    EVideoElementControllerBusEvent["VIDEO_PLAYBACK_STATE_CHANGED"] = "videoElementController.videoPlaybackStateChanged";
    EVideoElementControllerBusEvent["SET_VOLUME"] = "videoElementController.setVolume";
})($de1faff85a9c2843$export$60e3c1025821af4f || ($de1faff85a9c2843$export$60e3c1025821af4f = {}));






let $13e0e8c55e207599$var$countCheckingAutoPlay = 0;
class $13e0e8c55e207599$export$a9a0b55bc0093be5 {
    constructor(props){
        this._config = {};
        this._eventsMap = {
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).CAN_PLAY]: this._checkAutoplayEnabled,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).DESTROY]: this.destroy,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).FORCE_PLAY_AFTER_PAUSE]: this._forcePlayAfterPause,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).RESET_CHECKING_AUTOPLAY_COUNT]: this._resetCheckingAutoplayCount
        };
        this._state = props.state;
        this._eventBus = props.eventBus;
        this._logger = (0, $59dc5ffc15ec8449$export$efa9a398d6368992)(this._eventBus, "VideoElementController - AutoplayController");
        this._logger.info("Created");
        this._logger.debug("Initial config", this._config);
        this._logger.debug("Initial state", this._state);
        this.init();
    }
    setConfig(config) {
        this._logger.debug("Config update received, the new one:", config);
        this._config = config;
    }
    destroy() {
        this._logger.info("Destroying");
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners");
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _handleConfigUpdated() {}
    // Play/pause behaviour
    _forcePlayAfterPause(data) {
        if (this._config.autoplay !== undefined && !this._config.autoplay) {
            this._logger.verbose(`Autoplay is disabled.`);
            return;
        }
        this._logger.verbose(`Trying to force video to play.
    Reason: ${data.reason}`);
        const state = this._state.getState();
        if (!state.startedPlaying || state.isPlaying || this._config.canBePaused) {
            this._logger.verbose(`Currently unable to autoplay the video`);
            return;
        }
        this._checkAutoplayEnabled();
    }
    _checkAutoplayEnabled() {
        this._logger.debug("Checking if autoplay is possible");
        if (!this._state.getState().canPlay) {
            this._logger.verbose("No canPlay event caught, skipping check");
            return;
        }
        if (this._config.autoplay !== undefined && !this._config.autoplay) {
            this._logger.verbose(`Autoplay is disabled.`);
            return;
        }
        if ($13e0e8c55e207599$var$countCheckingAutoPlay > this._config.limitCheckingAutoplay) {
            this._logger.verbose(`Unable to autoplay the video. The limit of autoplay checking (${this._config.limitCheckingAutoplay}) is exceeded`);
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).PAUSED, {});
            return;
        }
        $13e0e8c55e207599$var$countCheckingAutoPlay += 1;
        this._logger.verbose("Autoplay is used to play the video");
        this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_START, {});
    }
    _resetCheckingAutoplayCount() {
        $13e0e8c55e207599$var$countCheckingAutoPlay = 0;
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $13e0e8c55e207599$export$a9a0b55bc0093be5.prototype, "destroy", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $13e0e8c55e207599$export$a9a0b55bc0093be5.prototype, "init", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $13e0e8c55e207599$export$a9a0b55bc0093be5.prototype, "_forcePlayAfterPause", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $13e0e8c55e207599$export$a9a0b55bc0093be5.prototype, "_checkAutoplayEnabled", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $13e0e8c55e207599$export$a9a0b55bc0093be5.prototype, "_resetCheckingAutoplayCount", null);



class $2698823e1558ee6a$export$493b9b82400bc18 extends EventTarget {
    constructor(){
        super();
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    emitEvent(type, data) {
        this.dispatchEvent(new CustomEvent(type, {
            detail: data
        }));
    }
}





class $b8fa44c52cf48ebe$export$17bfd6b0f11e369b extends (0, $2698823e1558ee6a$export$493b9b82400bc18) {
    constructor(props){
        super();
        this._eventsMap = {
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).PLAYING]: this._handlePlaying,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).LOADING]: this._handleLoading,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_PAUSE]: this._handlePause,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).CLICK]: this._handleClick,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).DESTROY]: this.destroy,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).NATIVE_EVENT]: this._handleNativeEvent,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).UPDATE_PLAYER_RESOLUTION]: this._handleUpdatePlayerResolution,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_PLAYBACK_STATE_CHANGED]: this._handleVideoPlaybackStateChange,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).TIME_UPDATE_NATIVE]: this._handleTimeUpdate
        };
        this._eventBus = props.eventBus;
        this.init();
    }
    destroy() {
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    init() {
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _handlePlaying(e) {
        this.emitEvent((0, $8836d3b72d09aae5$export$5de0c2f48b03ac5c).PLAYING, e);
    }
    _handleLoading() {
        this.emitEvent((0, $8836d3b72d09aae5$export$5de0c2f48b03ac5c).LOADING, {});
    }
    _handlePause() {
        this.emitEvent((0, $8836d3b72d09aae5$export$5de0c2f48b03ac5c).PAUSE, {});
    }
    _handleClick(e) {
        this.emitEvent((0, $8836d3b72d09aae5$export$5de0c2f48b03ac5c).CLICK, {
            originalEvent: e.originalEvent
        });
    }
    _handleNativeEvent(e) {
        this.emitEvent((0, $8836d3b72d09aae5$export$5de0c2f48b03ac5c).NATIVE_EVENT, e);
    }
    _handleUpdatePlayerResolution(e) {
        this.emitEvent((0, $8836d3b72d09aae5$export$5de0c2f48b03ac5c).UPDATE_PLAYER_RESOLUTION, e);
    }
    _handleTimeUpdate(e) {
        this.emitEvent((0, $8836d3b72d09aae5$export$5de0c2f48b03ac5c).TIME_UPDATE, e);
    }
    _handleVideoPlaybackStateChange(e) {
        this.emitEvent((0, $8836d3b72d09aae5$export$5de0c2f48b03ac5c).VIDEO_PLAYBACK_STATE_CHANGE, {
            prevState: e.prevState,
            nextState: e.nextState
        });
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "destroy", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "init", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handlePlaying", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleLoading", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handlePause", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleClick", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleNativeEvent", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleUpdatePlayerResolution", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleTimeUpdate", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleVideoPlaybackStateChange", null);






var $c0727f39ebbec036$exports = {};
!function(e, t) {
    $c0727f39ebbec036$exports = t();
}($c0727f39ebbec036$exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});


const $91039f54aac4c40b$var$browser = globalThis?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($c0727f39ebbec036$exports))).getParser(globalThis.navigator.userAgent) : null;
const $91039f54aac4c40b$var$safeSatisfies = (checkTree)=>{
    if (!$91039f54aac4c40b$var$browser) return false;
    return $91039f54aac4c40b$var$browser.satisfies(checkTree) || false;
};
const $91039f54aac4c40b$export$545916e689f11822 = {
    safari15OrHigher: $91039f54aac4c40b$var$safeSatisfies({
        safari: ">=15"
    }),
    firefox: $91039f54aac4c40b$var$safeSatisfies({
        firefox: ">0"
    }),
    safari: $91039f54aac4c40b$var$safeSatisfies({
        safari: ">0"
    }),
    chrome: $91039f54aac4c40b$var$safeSatisfies({
        chrome: ">0"
    }),
    edge: $91039f54aac4c40b$var$safeSatisfies({
        edge: ">0"
    })
};


/**
 * Wait this time if action does not return promise, ms
 *
 * @type {number}
 */ const $48670755c01aa66a$var$TIMEOUT = 150;
/**
 * Action promises mapped to player objects
 *
 * @type {WeakMap}
 */ const $48670755c01aa66a$var$promises = new WeakMap();
const $48670755c01aa66a$export$fce5b14c93a23464 = {
    /**
   * There is no data yet. Also, "readyState" property is HAVE_NOTHING.
   * About ready state: https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState
   */ EMPTY: 0,
    /**
   * HTMLMediaElement is active and has selected a resource, but is not using the network.
   */ IDLE: 1,
    /**
   * The browser is downloading HTMLMediaElement data.
   */ LOADING: 2,
    /**
   * No HTMLMediaElement src found.
   */ NO_SOURCE: 3
};
const $48670755c01aa66a$export$9db091a7aca4344 = {
    /**
   * No information is available about the media resource.
   */ HAVE_NOTHING: 0,
    /**
   * Enough of the media resource has been retrieved that the metadata attributes are initialized.
   * Seeking will no longer raise an exception.
   */ HAVE_METADATA: 1,
    /**
   * Data is available for the current playback position, but not enough to actually play more than one frame.
   */ HAVE_CURRENT_DATA: 2,
    /**
   * Data for the current playback position as well as for at least a little bit of time into
   * the future is available (in other words, at least two frames of video, for example).
   */ HAVE_FUTURE_DATA: 3,
    /**
   * Enough data is available—and the download rate is high enough—that the media can be played
   * through to the end without interruption.
   */ HAVE_ENOUGH_DATA: 4
};
const $48670755c01aa66a$export$cf60ee61610b0da4 = (player, action)=>{
    const isBadState = player.readyState === $48670755c01aa66a$export$9db091a7aca4344.HAVE_NOTHING;
    const isBadNetwork = player.networkState !== $48670755c01aa66a$export$fce5b14c93a23464.LOADING && player.networkState !== $48670755c01aa66a$export$fce5b14c93a23464.IDLE;
    if ((0, $91039f54aac4c40b$export$545916e689f11822).firefox && action === "play" && isBadState && isBadNetwork) throw new Error("Can not play audio");
};
const $48670755c01aa66a$export$c6f93ba583c9acfc = (player, action)=>{
    if (!(player instanceof HTMLMediaElement)) // Player seems to be unmounted
    return null;
    $48670755c01aa66a$export$cf60ee61610b0da4(player, action);
    if (typeof action === "function") // Function is provided
    return action(player);
    // Call player method
    return player[action]();
};
const $48670755c01aa66a$export$7f7f07871384d60f = (player, action)=>{
    const lastPromise = $48670755c01aa66a$var$promises.get(player);
    const activePromise = lastPromise || Promise.resolve();
    const promise = activePromise.then(()=>{
        const result = $48670755c01aa66a$export$c6f93ba583c9acfc(player, action);
        if (result?.then) // Wrap any then-able with promise
        return Promise.resolve(result);
        return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve(result);
            }, $48670755c01aa66a$var$TIMEOUT);
        });
    }).then(()=>{
        $48670755c01aa66a$var$promises.delete(player);
    }).catch((error)=>{
        $48670755c01aa66a$var$promises.delete(player);
        throw error;
    });
    $48670755c01aa66a$var$promises.set(player, promise);
    return promise;
};


class $0e423be0c289d786$export$900e53962f1f4ab1 {
    constructor(props){
        this._eventsMap = {
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_START]: this._startVideo,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_PAUSE]: this._pauseVideo,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_RESET]: this._resetVideo,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).RESTART]: this._restart,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).DESTROY]: this._destroy
        };
        this._state = props.state;
        this._eventBus = props.eventBus;
        this._logger = (0, $59dc5ffc15ec8449$export$efa9a398d6368992)(this._eventBus, "VideoElementController - PlaybackController");
        this._logger.info("Created");
        this._logger.debug("Initial state", this._state);
        this.init();
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners");
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _startVideo() {
        const videoElement = this._state.getState().videoElement;
        this._logger.verbose("Starting the video");
        if (videoElement) {
            if (!videoElement.playbackRate) videoElement.playbackRate = 1;
            this._logger.debug("Play call is added to the promises queue");
            return (0, $48670755c01aa66a$export$7f7f07871384d60f)(videoElement, "play").then(()=>{
                this._logger.debug("Play call resolved");
                if (this._state.getState().canPlay) this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).PLAYING, {});
            }).catch((e)=>{
                this._state.setState({
                    isAutoplayError: true
                });
                this._logger.error("An error occured when trying to play the video.", {
                    error: e
                });
                if (this._state.getState().canPlay) this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).PAUSED, {});
            });
        }
    }
    _pauseVideo() {
        this._logger.debug("Pausing the video");
        const videoElement = this._state.getState().videoElement;
        if (videoElement) {
            this._logger.debug("Pause call is added to the promises queue");
            return (0, $48670755c01aa66a$export$7f7f07871384d60f)(videoElement, "pause").then(()=>{
                this._logger.debug("Pause call resolved");
            }).catch((e)=>{
                this._logger.warn("Could not pause video", e);
            });
        }
    }
    _loadVideo() {
        this._logger.verbose("Loading the video");
        const videoElement = this._state.getState().videoElement;
        if (videoElement?.src && videoElement.src.startsWith("blob")) {
            this._logger.debug("Stream seems to be blob. Skipping load");
            return;
        }
        if (videoElement) {
            this._logger.debug("Load call is added to the promises queue");
            return (0, $48670755c01aa66a$export$7f7f07871384d60f)(videoElement, "load").then(()=>{
                this._logger.debug("Load call resolved");
            }).catch((e)=>{
                this._logger.warn("Could not load video", e);
            });
        }
    }
    _resetVideo() {
        this._logger.verbose("Resetting the video");
        const videoElement = this._state.getState().videoElement;
        if (videoElement) {
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).LOADING, {});
            this._loadVideo();
        }
    }
    async _restart() {
        this._logger.verbose("Restarting the video");
        await this._pauseVideo();
        // discuss questionable
        this._startVideo();
    }
    _destroy() {
        this._logger.info("Destroying");
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0e423be0c289d786$export$900e53962f1f4ab1.prototype, "init", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_startVideo", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_pauseVideo", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_loadVideo", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_resetVideo", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_restart", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_destroy", null);






const $159de6d7be0ecba7$export$97be80f4c9beb3f = (videoElement, volume)=>{
    if (!volume || volume < 0) {
        videoElement.muted = true;
        videoElement.volume = 0;
    } else {
        // todo
        const newVolume = Math.min(volume, 1);
        if (!isNaN(newVolume)) {
            videoElement.muted = false;
            videoElement.volume = newVolume;
        }
    }
};
const $159de6d7be0ecba7$export$8793edee2d425525 = ()=>{};
const $159de6d7be0ecba7$export$239446b37d3889f9 = (element)=>{
    if (element && element.parentNode) element.parentNode.removeChild(element);
};






const $c148f595ba898186$var$COMMON_STYLES = `
  width: 100%;
`;
class $c148f595ba898186$export$ff45b5d0a0c535a9 {
    constructor(props){
        this._knownVideoElementStyles = "";
        this._eventsMap = {
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).PLAYING]: this.startAnimationFrame,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).LOADING]: this.cancelAnimationFrame,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).REMOVE_MEDIA_STREAM]: this.cancelAnimationFrame
        };
        this._applyStyles = ()=>{
            this._logger.debug("Apply styles for canvas and video elements");
            const { canvasElement: canvasElement , videoElement: videoElement  } = this._getElements();
            if (!canvasElement || !videoElement) return;
            this._knownVideoElementStyles = videoElement.style.cssText;
            canvasElement.style.cssText = $c148f595ba898186$var$COMMON_STYLES;
            videoElement.style.cssText = `
      ${$c148f595ba898186$var$COMMON_STYLES}
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
    `;
        };
        this._state = props.state;
        this._eventBus = props.eventBus;
        this._logger = (0, $59dc5ffc15ec8449$export$efa9a398d6368992)(this._eventBus, "VideoElementController - CanvasVideoRenderer");
        const canvasElement = document.createElement("canvas");
        this._canvasContext = canvasElement.getContext("2d");
        if (props.className) canvasElement.className = props.className;
        this.init();
        this._state.setState({
            canvasElement: canvasElement
        });
        this._applyStyles();
        this._logger.verbose("Canvas renderer has been created");
    }
    startAnimationFrame() {
        const { canvasElement: canvasElement , videoElement: videoElement  } = this._getElements();
        this.cancelAnimationFrame();
        if (!canvasElement || !videoElement) return;
        const { width: width , height: height  } = canvasElement.getBoundingClientRect();
        const { videoWidth: videoWidth , videoHeight: videoHeight  } = videoElement;
        const containerAspectRatio = width / height;
        const videoAspectRatio = videoWidth / videoHeight;
        if (containerAspectRatio < 1 && videoAspectRatio > 1) {
            const imageWidth = Math.max(width, videoWidth);
            const imageHeight = videoHeight * (width / videoWidth);
            const dx = width > imageWidth ? (width - imageWidth) / 2 : 0;
            const dy = (height - imageHeight) / 2;
            if (this._canvasContext) {
                const ratio = devicePixelRatio;
                canvasElement.width = imageWidth * ratio;
                canvasElement.height = height * ratio;
                this._canvasContext.scale(ratio, ratio);
            }
            this._canvasContext?.drawImage(videoElement, dx, dy, imageWidth, imageHeight);
        } else {
            const imageHeight = Math.max(height, videoHeight);
            const imageWidth = videoWidth * (height / videoHeight);
            const dy = height > imageHeight ? (height - imageHeight) / 2 : 0;
            const dx = (width - imageWidth) / 2;
            if (this._canvasContext) {
                const ratio = devicePixelRatio;
                canvasElement.width = width * ratio;
                canvasElement.height = imageHeight * ratio;
                this._canvasContext.scale(ratio, ratio);
            }
            this._canvasContext?.drawImage(videoElement, dx, dy, imageWidth, imageHeight);
        }
        if (!this._state.getState().isLoading) this._canvasAnimationFrameId = requestAnimationFrame(this.startAnimationFrame);
    }
    getCanvasElement() {
        return this._getElements().canvasElement;
    }
    destroy() {
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
        const { canvasElement: canvasElement , videoElement: videoElement  } = this._getElements();
        if (canvasElement && canvasElement.parentNode) canvasElement.parentNode.removeChild(canvasElement);
        if (videoElement) {
            videoElement.style.cssText = this._knownVideoElementStyles;
            this._knownVideoElementStyles = "";
        }
        this._state.setState({
            canvasElement: null
        });
        this._logger.verbose("Canvas renderer was destroyed");
    }
    init() {
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    cancelAnimationFrame() {
        if (this._canvasAnimationFrameId) {
            cancelAnimationFrame(this._canvasAnimationFrameId);
            this._canvasAnimationFrameId = null;
        }
    }
    _getElements() {
        const { videoElement: videoElement , canvasElement: canvasElement  } = this._state.getState();
        return {
            videoElement: videoElement,
            canvasElement: canvasElement
        };
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $c148f595ba898186$export$ff45b5d0a0c535a9.prototype, "startAnimationFrame", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $c148f595ba898186$export$ff45b5d0a0c535a9.prototype, "destroy", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $c148f595ba898186$export$ff45b5d0a0c535a9.prototype, "init", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $c148f595ba898186$export$ff45b5d0a0c535a9.prototype, "cancelAnimationFrame", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $c148f595ba898186$export$ff45b5d0a0c535a9.prototype, "_getElements", null);


class $bdd9a250938bedd7$export$61525c45d39f05de {
    constructor(props){
        this._canvasVideoRenderer = null;
        this._config = {};
        this._isLocalVideo = false;
        this._eventsMap = {
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).SET_VOLUME]: this._setVolume,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).DESTROY]: this._destroy
        };
        this._state = props.state;
        this._eventBus = props.eventBus;
        this._logger = (0, $59dc5ffc15ec8449$export$efa9a398d6368992)(this._eventBus, "VideoElementController - RenderController");
        this._logger.info("Created");
        this._logger.debug("Initial config", this._config);
        this._logger.debug("Initial state", this._state);
        this.init();
    }
    setConfig(config) {
        this._logger.debug("Config update received, the new one:", config);
        this._config = config;
        this.applyConfigToVideoElement();
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners");
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    getElements() {
        const { videoElement: videoElement , canvasElement: canvasElement , ownContainer: ownContainer  } = this._state.getState();
        return {
            videoElement: videoElement,
            canvasElement: canvasElement,
            ownContainer: ownContainer
        };
    }
    getVideoElement() {
        return this.getElements().videoElement;
    }
    getCanvasElement() {
        return this.getElements().canvasElement;
    }
    renderVideoInto(container) {
        const { ownContainer: ownContainer , videoElement: videoElement  } = this.getElements();
        this._logger.debug("renderVideoInto method was called");
        let hasBeenRendered = false;
        if (container && videoElement) {
            const renderTarget = ownContainer || container;
            if (videoElement.parentElement !== renderTarget) {
                hasBeenRendered = true;
                renderTarget.appendChild(videoElement);
            }
            const canvasElement = this._canvasVideoRenderer?.getCanvasElement();
            if (this._canvasVideoRenderer && canvasElement?.parentElement !== renderTarget) {
                hasBeenRendered = true;
                renderTarget.appendChild(canvasElement);
                this._logger.info("Canvas element has been rendered to DOM");
            }
            if (renderTarget === ownContainer && ownContainer.parentElement !== container) {
                hasBeenRendered = true;
                container.appendChild(ownContainer);
            }
            if (hasBeenRendered) this._logger.info("Video element has been rendered to DOM");
            else this._logger.verbose("Skipping video element render: video element is already mounted to the DOM.");
        }
    }
    setVideoElement(videoElement, ownContainer) {
        this._logger.debug("Video element updated", {
            videoElement: videoElement
        });
        if (videoElement === this.getVideoElement()) {
            this._logger.verbose("Received video element is equal to the previous one. Skipping");
            return;
        }
        if (this._isLocalVideo) {
            this._logger.verbose("Removing video element and container from document");
            (0, $159de6d7be0ecba7$export$239446b37d3889f9)(this.getElements().videoElement);
            (0, $159de6d7be0ecba7$export$239446b37d3889f9)(this.getElements().ownContainer);
        }
        this._state.setState({
            videoElement: videoElement,
            ownContainer: ownContainer
        });
        this.applyConfigToVideoElement();
    }
    applyConfigToVideoElement() {
        this._logger.debug("Applying config to the video element");
        if (!this.getVideoElement()) {
            this._logger.verbose("No video element known, could not apply config");
            return;
        }
        const videoElement = this.getVideoElement();
        if (!videoElement) return;
        const { isNonAnonymous: isNonAnonymous , isMuted: isMuted , nativeControls: nativeControls , videoElementClassName: videoElementClassName , canvasElementClassName: canvasElementClassName , shouldUseCanvas: shouldUseCanvas , rootElement: rootElement , autoplay: autoplay  } = this._config;
        this._logger.verbose("Applied config", this._config);
        if (autoplay) videoElement.autoplay = true;
        videoElement.playsInline = true;
        if (nativeControls !== undefined) videoElement.controls = !!nativeControls;
        if (isMuted !== undefined) videoElement.muted = !!isMuted;
        if (isNonAnonymous !== undefined) {
            if (!isNonAnonymous) videoElement.crossOrigin = "anonymous";
            else videoElement.removeAttribute("crossOrigin");
        }
        // we will remove this classname later, if canvas element will be used
        if (videoElementClassName) videoElement.className = videoElementClassName;
        const volume = [
            this._state.getState().volume,
            this._config.volume
        ].find((v)=>v !== undefined);
        if (volume !== undefined) this._setVolume({
            volume: volume
        });
        if (shouldUseCanvas && !this._canvasVideoRenderer) {
            this._logger.verbose("Adding canvas as requested");
            this._addCanvasVideoRenderer();
            if (this._state.getState().isPlaying) this._canvasVideoRenderer.startAnimationFrame();
        }
        if (!shouldUseCanvas && this._canvasVideoRenderer) {
            const stream = this._state.getState().stream;
            this._logger.verbose("Removing canvas renderer");
            if (stream) this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).UPDATE_MEDIA_STREAM, stream);
            this._destroyCanvasRenderer();
        }
        const canvasElement = this.getCanvasElement();
        if (canvasElement) {
            videoElement.className = "";
            if (canvasElementClassName) canvasElement.className = canvasElementClassName;
        }
        // console.log('rendercontroller rootelement', rootElement);
        if (rootElement) this.renderVideoInto(rootElement);
    }
    destroy() {
        this._logger.info("Destroying");
        this._destroyCanvasRenderer();
        if (this._isLocalVideo) {
            this._logger.debug("Removing video element and container from document in destroy");
            const { videoElement: videoElement , ownContainer: ownContainer  } = this.getElements();
            (0, $159de6d7be0ecba7$export$239446b37d3889f9)(videoElement);
            (0, $159de6d7be0ecba7$export$239446b37d3889f9)(ownContainer);
        }
    }
    createVideoElement() {
        this._logger.info("Creating video element");
        let videoElement;
        let ownContainer;
        if (this._config.videoElement) {
            this._logger.debug("External video element passed from config - using existing one", this._config.videoElement);
            this._isLocalVideo = false;
            videoElement = this._config.videoElement;
        } else {
            this._isLocalVideo = true;
            videoElement = document.createElement("video");
            ownContainer = document.createElement("div");
            this._logger.debug("No external video element provided in config - created the new one", {
                videoElement: videoElement,
                ownContainer: ownContainer
            });
            ownContainer.style.position = "relative";
        }
        this.setVideoElement(videoElement, ownContainer);
        this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_ELEMENT_RECREATED, {
            videoElement: this.getVideoElement()
        });
    }
    _addCanvasVideoRenderer() {
        this._logger.debug("Adding canvas renderer");
        if (!this._canvasVideoRenderer) this._canvasVideoRenderer = new (0, $c148f595ba898186$export$ff45b5d0a0c535a9)({
            videoElement: this.getVideoElement(),
            className: this._config.videoElementClassName,
            state: this._state,
            eventBus: this._eventBus
        });
    }
    _destroyCanvasRenderer() {
        this._logger.debug("Destroying canvas renderer");
        if (this._canvasVideoRenderer) {
            this._canvasVideoRenderer.destroy();
            this._canvasVideoRenderer = null;
        }
    }
    _setVolume({ volume: volume  }) {
        const videoElement = this.getVideoElement();
        if (videoElement) {
            (0, $159de6d7be0ecba7$export$97be80f4c9beb3f)(videoElement, volume);
            this._logger.verbose(`Video volume level has been set to ${volume}`);
        }
    }
    _destroy() {
        this._logger.info("Destroying");
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bdd9a250938bedd7$export$61525c45d39f05de.prototype, "getElements", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bdd9a250938bedd7$export$61525c45d39f05de.prototype, "getVideoElement", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bdd9a250938bedd7$export$61525c45d39f05de.prototype, "getCanvasElement", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bdd9a250938bedd7$export$61525c45d39f05de.prototype, "renderVideoInto", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bdd9a250938bedd7$export$61525c45d39f05de.prototype, "setVideoElement", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bdd9a250938bedd7$export$61525c45d39f05de.prototype, "applyConfigToVideoElement", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bdd9a250938bedd7$export$61525c45d39f05de.prototype, "createVideoElement", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bdd9a250938bedd7$export$61525c45d39f05de.prototype, "_addCanvasVideoRenderer", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bdd9a250938bedd7$export$61525c45d39f05de.prototype, "_destroyCanvasRenderer", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bdd9a250938bedd7$export$61525c45d39f05de.prototype, "_setVolume", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bdd9a250938bedd7$export$61525c45d39f05de.prototype, "_destroy", null);







class $04304713e5d9da2c$export$9456d357203666ac {
    constructor(props){
        this._config = {};
        this._eventsMap = {
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).PLAYING]: this._handlePlaying,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).LOADING]: this._handleLoading,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_PAUSE]: this._handlePause,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).CAN_PLAY]: this._handleCanPlay,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).PAUSED]: this._handlePaused,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).RESTART]: this._handleRestart,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).UPDATED]: this._handleUpdate,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).STALLED]: this._handleStalled,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).WAITING]: this._handleWaiting,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).UPDATE_PLAYER_RESOLUTION]: this._handleUpdatePlayerResolution,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).ERROR]: this._handleError,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).SET_VOLUME]: this._handleSetVolume,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).DESTROY]: this.destroy
        };
        this._state = props.state;
        this._eventBus = props.eventBus;
        this._logger = (0, $59dc5ffc15ec8449$export$efa9a398d6368992)(this._eventBus, "VideoElementController - StateController");
        this._logger.info("Created");
        this._logger.verbose("Initial state", props.state);
        this.init();
    }
    setConfig(config) {
        this._logger.debug("Config update received, the new one:", config);
        this._config = config;
    }
    destroy() {
        this._logger.info("Destroy");
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
        this._state.resetState();
        this._state.setState({
            isDestroyed: true
        });
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners");
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _updateState(newState) {
        const prevPlaybackState = this._state.getState().videoPlaybackState;
        let nextPlaybackState = prevPlaybackState;
        // TODO: Set PlaybackState directly instead of using boolean flags.
        if (newState.isPlaying) nextPlaybackState = (0, $2b02fdf3c00e51bd$export$af29ccb356acd9fc).PLAYING;
        else if (newState.isLoading) nextPlaybackState = (0, $2b02fdf3c00e51bd$export$af29ccb356acd9fc).LOADING;
        else if (newState.isPaused) nextPlaybackState = (0, $2b02fdf3c00e51bd$export$af29ccb356acd9fc).PAUSED;
        else if (newState.isError) nextPlaybackState = (0, $2b02fdf3c00e51bd$export$af29ccb356acd9fc).ERROR;
        this._logger.debug(`State updated: ${prevPlaybackState} -> ${nextPlaybackState}`);
        this._state.setState({
            ...newState,
            videoPlaybackState: nextPlaybackState
        });
        if (prevPlaybackState !== nextPlaybackState) this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_PLAYBACK_STATE_CHANGED, {
            prevState: prevPlaybackState,
            nextState: nextPlaybackState
        });
    }
    _handlePlaying() {
        this._logger.debug("Playing event received");
        this._updateState({
            isPlaying: true,
            startedPlaying: true,
            isLoading: false,
            isStalled: false,
            isWaiting: false,
            isPaused: false,
            isError: false
        });
    }
    _handleLoading() {
        this._logger.debug("Loading event received");
        this._updateState({
            isLoading: true,
            isPlaying: false
        });
    }
    _handlePause() {
        this._logger.debug("Pause event received");
        this._updateState({
            isPlaying: false,
            isPaused: true
        });
    }
    _handlePaused() {
        this._logger.debug("Paused event received");
        this._updateState({
            isPlaying: false,
            isLoading: false,
            isPaused: true
        });
    }
    _handleCanPlay() {
        this._logger.debug("CanPlay event received");
        this._updateState({
            canPlay: true,
            isDestroyed: false
        });
    }
    _handleRestart() {
        this._logger.debug("Restart event received");
        this._updateState({
            isRestarted: true
        });
    }
    _handleStalled() {
        this._logger.debug("Stalled event received");
        this._updateState({
            isStalled: true
        });
    }
    _handleWaiting() {
        this._logger.debug("Waiting event received");
        this._updateState({
            isWaiting: true
        });
    }
    _handleError() {
        this._logger.debug("Error event received");
        this._updateState({
            isError: true
        });
    }
    _handleSetVolume({ volume: volume  }) {
        this._logger.debug("Volume event received", {
            volume: volume
        });
        this._updateState({
            volume: volume
        });
    }
    _handleUpdatePlayerResolution(e) {
        this._logger.debug("Player resolution event received", {
            height: e.height,
            width: e.width
        });
        this._updateState({
            videoElementResolution: {
                height: e.height,
                width: e.width
            }
        });
    }
    _handleUpdate() {
        this._logger.debug("Update event received");
        this._updateState({
            canPlay: false,
            isLoading: true,
            isPlaying: false,
            isRestarted: false,
            isPaused: false,
            isError: false
        });
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "destroy", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "init", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_updateState", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handlePlaying", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleLoading", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handlePause", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handlePaused", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleCanPlay", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleRestart", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleStalled", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleWaiting", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleError", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleSetVolume", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleUpdatePlayerResolution", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleUpdate", null);






class $fa81a3aa7a22efa4$export$450c54b9e8861ae8 {
    constructor(props){
        this._config = {};
        this._eventsMap = {
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).PLAYING]: this._cancelResetStream,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).LOADING]: this._cancelResetStream,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).LOADED]: this._cancelResetStream,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).PAUSED]: this._cancelResetStream,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).UPDATED]: this._cancelResetStream,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).CANCEL_RESET_STREAM]: this._cancelResetStream,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).STREAM_RESET]: this._resetStream,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).UPDATE_MEDIA_STREAM]: this.updateMediaStream,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).DESTROY]: this.destroy
        };
        this._getIsSrcObjectAvailable = ()=>this._props.getVideoElement()?.srcObject !== undefined;
        this._state = props.state;
        this._eventBus = props.eventBus;
        this._logger = (0, $59dc5ffc15ec8449$export$efa9a398d6368992)(this._eventBus, "VideoElementController - StreamController");
        this._props = props;
        this._logger.info("Created");
        this._logger.verbose("Initial state", props.state);
        this.init();
    }
    setConfig(config) {
        this._logger.debug("Config update received, the new one:", config);
        this._config = config;
    }
    updateMediaStream(stream) {
        this._logger.info("Updating media stream", {
            stream: stream
        });
        const videoElement = this._props.getVideoElement();
        if (!videoElement) {
            this._logger.debug("No video element known. Skipping media stream update");
            return;
        }
        this._attachStream(stream);
        this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_START, {});
    }
    removeMediaStream() {
        this._logger.info("Removing media stream");
        const videoElement = this._props.getVideoElement();
        if (!videoElement) {
            this._logger.debug("No video element known. Skipping media stream remove");
            return;
        }
        this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_PAUSE, {});
        this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).REMOVE_MEDIA_STREAM, {});
        if (this._getIsSrcObjectAvailable()) {
            this._logger.debug("Setting srcObject to null");
            videoElement.srcObject = null;
        } else {
            this._logger.debug("Revoking object url", {
                url: videoElement.src
            });
            window.URL.revokeObjectURL(videoElement.src);
        }
        if (videoElement.src) {
            this._logger.debug("Removing src attribute from video");
            videoElement.removeAttribute("src");
        }
    }
    destroy() {
        this._logger.info("Destroying");
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners");
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _attachStream(stream) {
        this._logger.info("Attaching media stream", {
            stream: stream
        });
        const videoElement = this._props.getVideoElement();
        if (!videoElement || !stream) {
            this._logger.debug("No video element or stream defined. Skipping stream set");
            return;
        }
        if (videoElement.src === stream) {
            this._logger.debug("Current video element src attribute value is equal to the new stream. Skipping stream set");
            return;
        }
        if (typeof stream === "string") {
            this._logger.debug("Setting video element src attribute");
            videoElement.src = stream;
        } else if (this._getIsSrcObjectAvailable()) {
            this._logger.debug("Setting video element srcObject attribute");
            videoElement.srcObject = stream;
        } else {
            videoElement.src = window.URL.createObjectURL(stream);
            this._logger.debug(`Got MediaStream as stream, but srcObject is not available. Created new object URL: ${videoElement.src}`);
        }
    }
    _cancelResetStream() {
        this._logger.debug("Stream reset action cancel required");
        if (this._streamResetDelayId) {
            clearTimeout(this._streamResetDelayId);
            this._logger.debug("Stream reset action cancelled");
        }
    }
    _resetStream({ timeout: timeout  }) {
        this._logger.debug("Reset stream required");
        if (!timeout) {
            this._logger.verbose("No timeout set, skipping stream reset", {
                timeout: timeout
            });
            return;
        }
        this._cancelResetStream();
        this._streamResetDelayId = setTimeout(()=>{
            this._logger.debug("Resetting stream timeout fired");
            let hasStreamReset = false;
            if (this._config.onResetStream) hasStreamReset = this._config.onResetStream();
            const stream = this._state.getState().stream;
            if (stream && !hasStreamReset) {
                if (typeof stream === "string" && stream.startsWith("blob")) {
                    this._logger.debug("Streams seems to be object url. Skipping reset");
                    return;
                }
                this._logger.debug("Resetting stream");
                this.removeMediaStream();
                this.updateMediaStream(stream);
            }
        }, timeout);
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "updateMediaStream", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "removeMediaStream", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "destroy", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "init", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "_attachStream", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "_cancelResetStream", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "_resetStream", null);





/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $bc79732bdee1cb1c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $bc79732bdee1cb1c$export$2e2bcd8739ae039 = $bc79732bdee1cb1c$var$isObject;


/** Detect free variable `global` from Node.js. */ var $24b6e30a1afa8600$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $24b6e30a1afa8600$export$2e2bcd8739ae039 = $24b6e30a1afa8600$var$freeGlobal;


/** Detect free variable `self`. */ var $d8f779c4d6a85fc3$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $d8f779c4d6a85fc3$var$root = (0, $24b6e30a1afa8600$export$2e2bcd8739ae039) || $d8f779c4d6a85fc3$var$freeSelf || Function("return this")();
var $d8f779c4d6a85fc3$export$2e2bcd8739ae039 = $d8f779c4d6a85fc3$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $7e8ac0beb1209be8$var$now = function() {
    return (0, $d8f779c4d6a85fc3$export$2e2bcd8739ae039).Date.now();
};
var $7e8ac0beb1209be8$export$2e2bcd8739ae039 = $7e8ac0beb1209be8$var$now;


/** Used to match a single whitespace character. */ var $8d5dfc340f49e243$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $8d5dfc340f49e243$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $8d5dfc340f49e243$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $8d5dfc340f49e243$export$2e2bcd8739ae039 = $8d5dfc340f49e243$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $6f3fa1903d866976$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $6f3fa1903d866976$var$baseTrim(string) {
    return string ? string.slice(0, (0, $8d5dfc340f49e243$export$2e2bcd8739ae039)(string) + 1).replace($6f3fa1903d866976$var$reTrimStart, "") : string;
}
var $6f3fa1903d866976$export$2e2bcd8739ae039 = $6f3fa1903d866976$var$baseTrim;




/** Built-in value references. */ var $9157a096b1199bf9$var$Symbol = (0, $d8f779c4d6a85fc3$export$2e2bcd8739ae039).Symbol;
var $9157a096b1199bf9$export$2e2bcd8739ae039 = $9157a096b1199bf9$var$Symbol;



/** Used for built-in method references. */ var $a30b48268704b0e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a30b48268704b0e8$var$hasOwnProperty = $a30b48268704b0e8$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a30b48268704b0e8$var$nativeObjectToString = $a30b48268704b0e8$var$objectProto.toString;
/** Built-in value references. */ var $a30b48268704b0e8$var$symToStringTag = (0, $9157a096b1199bf9$export$2e2bcd8739ae039) ? (0, $9157a096b1199bf9$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $a30b48268704b0e8$var$getRawTag(value) {
    var isOwn = $a30b48268704b0e8$var$hasOwnProperty.call(value, $a30b48268704b0e8$var$symToStringTag), tag = value[$a30b48268704b0e8$var$symToStringTag];
    try {
        value[$a30b48268704b0e8$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $a30b48268704b0e8$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$a30b48268704b0e8$var$symToStringTag] = tag;
        else delete value[$a30b48268704b0e8$var$symToStringTag];
    }
    return result;
}
var $a30b48268704b0e8$export$2e2bcd8739ae039 = $a30b48268704b0e8$var$getRawTag;


/** Used for built-in method references. */ var $aae707dc648e7bf6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $aae707dc648e7bf6$var$nativeObjectToString = $aae707dc648e7bf6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $aae707dc648e7bf6$var$objectToString(value) {
    return $aae707dc648e7bf6$var$nativeObjectToString.call(value);
}
var $aae707dc648e7bf6$export$2e2bcd8739ae039 = $aae707dc648e7bf6$var$objectToString;


/** `Object#toString` result references. */ var $7e36e37176e453f4$var$nullTag = "[object Null]", $7e36e37176e453f4$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $7e36e37176e453f4$var$symToStringTag = (0, $9157a096b1199bf9$export$2e2bcd8739ae039) ? (0, $9157a096b1199bf9$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $7e36e37176e453f4$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $7e36e37176e453f4$var$undefinedTag : $7e36e37176e453f4$var$nullTag;
    return $7e36e37176e453f4$var$symToStringTag && $7e36e37176e453f4$var$symToStringTag in Object(value) ? (0, $a30b48268704b0e8$export$2e2bcd8739ae039)(value) : (0, $aae707dc648e7bf6$export$2e2bcd8739ae039)(value);
}
var $7e36e37176e453f4$export$2e2bcd8739ae039 = $7e36e37176e453f4$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9d3a44815d630612$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $9d3a44815d630612$export$2e2bcd8739ae039 = $9d3a44815d630612$var$isObjectLike;


/** `Object#toString` result references. */ var $1c2e263c03ecb113$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1c2e263c03ecb113$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $9d3a44815d630612$export$2e2bcd8739ae039)(value) && (0, $7e36e37176e453f4$export$2e2bcd8739ae039)(value) == $1c2e263c03ecb113$var$symbolTag;
}
var $1c2e263c03ecb113$export$2e2bcd8739ae039 = $1c2e263c03ecb113$var$isSymbol;


/** Used as references for various `Number` constants. */ var $5c6d99771e1bfba7$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $5c6d99771e1bfba7$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $5c6d99771e1bfba7$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $5c6d99771e1bfba7$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $5c6d99771e1bfba7$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $5c6d99771e1bfba7$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $1c2e263c03ecb113$export$2e2bcd8739ae039)(value)) return $5c6d99771e1bfba7$var$NAN;
    if ((0, $bc79732bdee1cb1c$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $bc79732bdee1cb1c$export$2e2bcd8739ae039)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $6f3fa1903d866976$export$2e2bcd8739ae039)(value);
    var isBinary = $5c6d99771e1bfba7$var$reIsBinary.test(value);
    return isBinary || $5c6d99771e1bfba7$var$reIsOctal.test(value) ? $5c6d99771e1bfba7$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $5c6d99771e1bfba7$var$reIsBadHex.test(value) ? $5c6d99771e1bfba7$var$NAN : +value;
}
var $5c6d99771e1bfba7$export$2e2bcd8739ae039 = $5c6d99771e1bfba7$var$toNumber;


/** Error message constants. */ var $5d86449096afd213$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5d86449096afd213$var$nativeMax = Math.max, $5d86449096afd213$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $5d86449096afd213$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($5d86449096afd213$var$FUNC_ERROR_TEXT);
    wait = (0, $5c6d99771e1bfba7$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $bc79732bdee1cb1c$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $5d86449096afd213$var$nativeMax((0, $5c6d99771e1bfba7$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $5d86449096afd213$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $7e8ac0beb1209be8$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $7e8ac0beb1209be8$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $7e8ac0beb1209be8$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $5d86449096afd213$export$2e2bcd8739ae039 = $5d86449096afd213$var$debounce;



/** Error message constants. */ var $335f0fe42866c308$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $335f0fe42866c308$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($335f0fe42866c308$var$FUNC_ERROR_TEXT);
    if ((0, $bc79732bdee1cb1c$export$2e2bcd8739ae039)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, $5d86449096afd213$export$2e2bcd8739ae039)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $335f0fe42866c308$export$2e2bcd8739ae039 = $335f0fe42866c308$var$throttle;




const $0b302ff0925c3ef2$var$TIMEOUT_UPDATE_STATUS_PLAYING = 2000;
const $0b302ff0925c3ef2$var$STORAGE_KEY_WAS_RESTARTED = "ristrettoWasRestarted";
let $0b302ff0925c3ef2$var$timerCheckPrevTime = 0;
let $0b302ff0925c3ef2$var$prevTime = 0;
class $0b302ff0925c3ef2$export$25e21b090bbc69f9 {
    constructor(props){
        this._shouldSetNextUpdateVideoDurationId = true;
        this._config = {};
        this._onNativeTimeUpdateHandlerThrottled = (0, $335f0fe42866c308$export$2e2bcd8739ae039)(this._onNativeTimeUpdateHandler, $0b302ff0925c3ef2$var$TIMEOUT_UPDATE_STATUS_PLAYING, {
            trailing: false
        });
        this._eventsMap = {
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).TIME_UPDATE_NATIVE]: this._onNativeTimeUpdateHandlerThrottled,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).DESTROY]: this._destroy
        };
        this._state = props.state;
        this._eventBus = props.eventBus;
        this._logger = (0, $59dc5ffc15ec8449$export$efa9a398d6368992)(this._eventBus, "VideoElementController - TimeUpdateController");
        this._props = props;
        this._logger.info("Created");
        this._logger.debug("Initial state", props.state);
        this._logger.debug("Initial props", props);
    }
    setConfig(config) {
        this._logger.debug("Config update received, the new one:", config);
        const hasTimeoutStatusPlayingChanged = config.timeoutUpdateStatusPlaying !== this._config.timeoutUpdateStatusPlaying;
        this._config = config;
        if (hasTimeoutStatusPlayingChanged) {
            this._eventsMap[(0, $de1faff85a9c2843$export$60e3c1025821af4f).TIME_UPDATE_NATIVE] = (0, $335f0fe42866c308$export$2e2bcd8739ae039)(this._onNativeTimeUpdateHandler, config.timeoutUpdateStatusPlaying, {
                trailing: false
            });
            this._eventBus.toggleSubscriptionBulk({
                action: "unsubscribe",
                callbacks: this._eventsMap
            });
            this.init();
        }
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners");
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    startTimeUpdate() {
        this._stopTimeUpdate();
        if (!this._shouldSetNextUpdateVideoDurationId || !this._config) {
            this._shouldSetNextUpdateVideoDurationId = true;
            return;
        }
        this._updateVideoDurationId = setTimeout(this._onTimeUpdate, this._config.timeoutUpdateVideoDuration);
        this._publishUpdatePlayerResolutionIfNeeded();
    }
    _onNativeTimeUpdateHandler(e) {
        this._logger.debug("Native video timeUpdate caught");
        if (e?.originalEvent?.defaultPrevented) return;
        const videoElement = this._props.getVideoElement();
        const { canPlay: canPlay , isPlaying: isPlaying , isLoading: isLoading , isRestarted: isRestarted  } = this._state.getState();
        this._publishUpdatePlayerResolutionIfNeeded();
        if (!canPlay) {
            this._logger.verbose("CanPlay shared state is false. Skipping");
            return;
        }
        this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).RESET_CHECKING_AUTOPLAY_COUNT, {});
        const isTimeChanged = $0b302ff0925c3ef2$var$timerCheckPrevTime !== videoElement?.currentTime;
        this._logger.verbose(`Video current time is ${isTimeChanged ? "" : "not"} changed`);
        if (isTimeChanged) {
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).CANCEL_RESET_STREAM, {});
            if ((0, $91039f54aac4c40b$export$545916e689f11822).safari15OrHigher && !isRestarted && !localStorage?.getItem($0b302ff0925c3ef2$var$STORAGE_KEY_WAS_RESTARTED)) {
                localStorage.setItem($0b302ff0925c3ef2$var$STORAGE_KEY_WAS_RESTARTED, "1");
                // This hack must fix very rare bug on safari, when there is a black screen and the video is not playing.
                // This hack also causes unexpected behavior - playback state switches from playing to paused and then back to playing,
                // Which can lead to ui lagging and twitching. We don't want to remove the hack completely, but we want to minimize its usage.
                // So if we had to use the hack, we save a flag in localStorage and won't use the hack on the current browser anymore.
                // The bug is very rare and may reproduce only once - when we first open video on a freshly installed Safari.
                this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).RESTART, {});
            }
            if (videoElement) $0b302ff0925c3ef2$var$timerCheckPrevTime = videoElement.currentTime;
            if (!isPlaying || isLoading) this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).PLAYING, {});
        } else if (!isLoading) this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).LOADING, {});
        else this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_RESET, {});
    }
    _stopTimeUpdate() {
        clearTimeout(this._updateVideoDurationId);
    }
    _onTimeUpdate() {
        if (!this._state.getState().canPlay) {
            this.startTimeUpdate();
            return;
        }
        const videoElement = this._props.getVideoElement();
        if (videoElement) {
            if ($0b302ff0925c3ef2$var$prevTime !== videoElement.currentTime) $0b302ff0925c3ef2$var$prevTime = videoElement.currentTime;
        }
        this.startTimeUpdate();
    }
    _publishUpdatePlayerResolutionIfNeeded() {
        const videoElement = this._props.getVideoElement();
        if (videoElement) {
            const { videoWidth: videoWidth , videoHeight: videoHeight  } = videoElement;
            const { videoElementResolution: videoElementResolution  } = this._state.getState();
            if ((!videoElementResolution || videoElementResolution.height !== videoHeight || videoElementResolution.width !== videoWidth) && this._config.minimalPossibleVideoDimension && Math.min(videoHeight, videoWidth) > this._config.minimalPossibleVideoDimension) {
                this._logger.verbose(`Stored resolution is ${videoElementResolution?.width}x${videoElementResolution?.height}, current is ${videoWidth}x${videoHeight}`);
                this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).UPDATE_PLAYER_RESOLUTION, {
                    width: videoWidth,
                    height: videoHeight
                });
            }
        }
    }
    _destroy() {
        this._logger.info("Destroying");
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
        this._shouldSetNextUpdateVideoDurationId = false;
        this._stopTimeUpdate();
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "init", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "startTimeUpdate", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "_onNativeTimeUpdateHandler", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "_stopTimeUpdate", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "_onTimeUpdate", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "_publishUpdatePlayerResolutionIfNeeded", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "_destroy", null);






class $12f7c2f2c1b55bfc$export$3a521cb24f143cc8 {
    constructor(props){
        this._config = {};
        this._timeUpdateEventWasLogged = false;
        this._eventsMap = {
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_ELEMENT_RECREATED]: this._handleVideoElementRecreated,
            [(0, $de1faff85a9c2843$export$60e3c1025821af4f).DESTROY]: this._handleDestroy
        };
        this._onVideoClick = (e)=>{
            this._logger.verbose('"click" video native event fired');
            this._handleNativeEvent(e);
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).CLICK, {
                originalEvent: e
            });
        };
        this._onSeeked = (e)=>{
            this._logger.verbose('"seeked" video native event fired');
            this._handleNativeEvent(e);
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).FORCE_PLAY_AFTER_PAUSE, {
                reason: "seeked video native event"
            });
        };
        this._onRateChange = (e)=>{
            this._logger.verbose('"ratechange" video native event fired');
            this._handleNativeEvent(e);
            if (e.target && !e.target.playbackRate) this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).FORCE_PLAY_AFTER_PAUSE, {
                reason: "video playbackRate is 0"
            });
        };
        this._onCanPlayThrough = (e)=>{
            this._logger.verbose('"canplaythrough" video native event fired');
            const state = this._state.getState();
            this._handleNativeEvent(e);
            if (state.isStalled || state.isWaiting) this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).FORCE_PLAY_AFTER_PAUSE, {
                reason: "canplaythrough video native event fired, and video is in the state of either stalled or waiting"
            });
        };
        this._onPlayingHandler = (e)=>{
            this._logger.verbose('"playing" video native event fired');
            this._logger.info("Video has started playing");
            this._handleNativeEvent(e);
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).PLAYING, {
                isAutoplay: !this._state.getState().isAutoplayError
            });
        };
        this._onAbortHandler = (e)=>{
            this._logger.verbose('"abort" video native event fired');
            this._handleNativeEvent(e);
            if (!e.defaultPrevented) this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).LOADING, {});
        };
        this._onPauseHandler = (e)=>{
            this._logger.verbose('"pause" video native event fired');
            this._handleNativeEvent(e);
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_PAUSE, {});
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).FORCE_PLAY_AFTER_PAUSE, {
                reason: "pause video event fired (most likely user paused the video manually)"
            });
        };
        this._onCanPlayHandler = (e)=>{
            this._logger.verbose('"canplay" video native event fired');
            this._handleNativeEvent(e);
            if (!e.defaultPrevented) {
                this._state.setState({
                    canPlay: true
                });
                this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).CAN_PLAY, {});
            }
        };
        this._onErrorHandler = (e)=>{
            this._logger.error('"error" video native event fired', {
                error: e
            });
            this._handleNativeEvent(e);
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).ERROR, {
                originalEvent: e
            });
            if (!e.defaultPrevented) {
                const { MEDIA_ERR_SRC_NOT_SUPPORTED: MEDIA_ERR_SRC_NOT_SUPPORTED  } = MediaError;
                const error = this._props.getVideoElement()?.error;
                const code = error?.code;
                if (code !== MEDIA_ERR_SRC_NOT_SUPPORTED) {
                    this._logger.verbose("Video element error is not of MEDIA_ERR_SRC_NOT_SUPPORTED kind. Requesting reset");
                    this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).VIDEO_RESET, {});
                }
            }
        };
        this._onTimeUpdateHandler = (e)=>{
            this._handleNativeEvent(e);
            if (!this._timeUpdateEventWasLogged) {
                this._logger.verbose('"timeupdate" video native event fired for the first time');
                this._timeUpdateEventWasLogged = true;
            }
            this._eventBus.publishSync((0, $de1faff85a9c2843$export$60e3c1025821af4f).TIME_UPDATE_NATIVE, {
                originalEvent: e
            });
        };
        this._onLoadStartHandler = (e)=>{
            this._handleNativeEvent(e);
            this._logger.verbose('"loadstart" video native event fired');
            const { timeoutUpdateStream: timeoutUpdateStream  } = this._config;
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).LOADING, {});
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).STREAM_RESET, {
                reason: "onLoadStartHandler",
                timeout: timeoutUpdateStream
            });
        };
        this._onLoadedDataHandler = (e)=>{
            this._logger.verbose('"loadeddata" video native event fired');
            this._handleNativeEvent(e);
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).LOADED, {});
        };
        this._onWaiting = (e)=>{
            this._logger.verbose('"waiting" video native event fired');
            const { timeoutWaitingStream: timeoutWaitingStream  } = this._config;
            this._handleNativeEvent(e);
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).WAITING, {});
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).LOADING, {});
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).STREAM_RESET, {
                reason: "onWaiting",
                timeout: timeoutWaitingStream
            });
        };
        this._onStalled = (e)=>{
            this._logger.verbose('"stalled" video native event fired');
            const { timeoutWaitingStream: timeoutWaitingStream  } = this._config;
            this._handleNativeEvent(e);
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).STALLED, {});
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).STREAM_RESET, {
                reason: "onStalled",
                timeout: timeoutWaitingStream
            });
        };
        this._onEndFullscreenHandler = (e)=>{
            this._handleNativeEvent(e);
        // this.config.onEndFullscreen!(e);
        };
        this._props = props;
        this._state = props.state;
        this._eventBus = props.eventBus;
        this._logger = (0, $59dc5ffc15ec8449$export$efa9a398d6368992)(this._eventBus, "VideoElementController - VideoEventsHandler");
        this.init();
    }
    setConfig(config) {
        this._config = config;
    }
    init() {
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    toggleEvents(action, overrideVideoElement) {
        const target = overrideVideoElement || this._props.getVideoElement();
        if (!target) return;
        const method = action === "attach" ? "addEventListener" : "removeEventListener";
        target[method]("click", this._onVideoClick);
        target[method]("playing", this._onPlayingHandler);
        target[method]("abort", this._onAbortHandler);
        target[method]("pause", this._onPauseHandler);
        target[method]("canplay", this._onCanPlayHandler);
        target[method]("error", this._onErrorHandler);
        target[method]("timeupdate", this._onTimeUpdateHandler);
        target[method]("loadstart", this._onLoadStartHandler);
        target[method]("loadeddata", this._onLoadedDataHandler);
        target[method]("waiting", this._onWaiting);
        target[method]("stalled", this._onStalled);
        target[method]("canplaythrough", this._onCanPlayThrough);
        target[method]("seeked", this._onSeeked);
        target[method]("ratechange", this._onRateChange);
        // // discuss
        target[method]("webkitendfullscreen", this._onEndFullscreenHandler);
        if (method === "addEventListener") this._logger.verbose(`event listeners are ATTACHED to the video element`);
        else this._logger.verbose(`event listeners are DETACHED from the video element`);
    }
    _handleVideoElementRecreated() {
        this.toggleEvents("attach");
    }
    _handleDestroy() {
        this.toggleEvents("detach");
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    _handleNativeEvent(e) {
        this._eventBus.publishSync((0, $de1faff85a9c2843$export$60e3c1025821af4f).NATIVE_EVENT, {
            eventName: e.type,
            event: e
        });
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $12f7c2f2c1b55bfc$export$3a521cb24f143cc8.prototype, "init", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $12f7c2f2c1b55bfc$export$3a521cb24f143cc8.prototype, "_handleVideoElementRecreated", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $12f7c2f2c1b55bfc$export$3a521cb24f143cc8.prototype, "_handleDestroy", null);



const $55f31eac363b323e$export$36d128238e6b60f5 = {
    canPlay: false,
    isLoading: true,
    isError: false,
    isAutoplayError: false,
    isPaused: false,
    isPlaying: false,
    isRestarted: false,
    isStalled: false,
    isWaiting: false,
    isDestroyed: false,
    videoPlaybackState: (0, $2b02fdf3c00e51bd$export$af29ccb356acd9fc).IDLE,
    startedPlaying: false
};


class $442b7bba03edb347$export$4d5c8163a511d38a {
    constructor(initialState){
        this._initState = {
            ...initialState
        };
        this._state = {
            ...initialState
        };
    }
    setState(state, cb) {
        Object.assign(this._state, state);
        if (cb) cb(this._state);
    }
    getState() {
        return this._state;
    }
    resetState() {
        this.setState(this._initState);
    }
}


class $4ec065df5e9ead04$export$6dab3502ba426410 {
    constructor(){
        this._config = {
            ...(0, $a99bfb4a2e753607$export$1d295a4981f9ea1e).videoElementControllerConfig
        };
        this.attachVideoElementEvents = ()=>{
            this._logger.debug("Attach event listeners");
            this._eventsHandler.toggleEvents("attach");
            this._timeUpdateController.startTimeUpdate();
        };
        this.detachVideoElementEvents = (overrideVideoElement)=>{
            this._logger.debug("Detach event listeners");
            this._eventsHandler.toggleEvents("detach", overrideVideoElement);
        };
        this._updated = ()=>{
            this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).UPDATED, {});
        };
        this._eventBus = new (0, $ae21521d6337de01$export$5087227eb54526)();
        this._loggerTransport = new (0, $6b88f92c0e0219d7$export$8734a8c908553955)(this._eventBus);
        this._logger = (0, $59dc5ffc15ec8449$export$efa9a398d6368992)(this._eventBus, "VideoController");
        this._logger.info("Created");
        this._logger.debug("Initial config", this._config);
        this._createControllers();
    }
    addEventListener(event, cb) {
        this._logger.verbose(`Attaching ${event} event listener`);
        this._customEventsEmitter.addEventListener(event, cb);
    }
    removeEventListener(event, cb) {
        this._logger.verbose(`Detaching ${event} event listener`);
        this._customEventsEmitter.removeEventListener(event, cb);
    }
    getIsPlaying() {
        return this._state.getState().isPlaying;
    }
    getVideoElement() {
        return this._state.getState().videoElement;
    }
    getCanvasElement() {
        return this._state.getState().canvasElement;
    }
    updateConfig(config) {
        this._config = {
            ...this._config,
            ...config
        };
        this._logger.debug("Config update received, the new one: ", this._config);
        if (config.isRemote) this.attachVideoElementEvents();
        this._syncConfig();
    }
    setVideoElement(videoElement) {
        const currentVideoElement = this._state.getState().videoElement;
        if (videoElement === currentVideoElement) return;
        if (currentVideoElement) this.detachVideoElementEvents(currentVideoElement);
        this._logger.info("Video element set", {
            videoElement: videoElement
        });
        this._renderController.setVideoElement(videoElement);
        this.attachVideoElementEvents();
    }
    createVideoElement() {
        this._logger.info("Creating video element");
        this._renderController.createVideoElement();
        return this.getVideoElement();
    }
    setStream(stream) {
        this._logger.info("Setting media stream");
        const prevStream = this._state.getState().stream;
        if (prevStream === stream) {
            this._logger.verbose("Previous stream is equal to the new one. Skipping.");
            return;
        }
        if (stream) this._streamController.updateMediaStream(stream);
        else this._streamController.removeMediaStream();
        this._updated();
        this._state.setState({
            stream: stream
        });
        return this;
    }
    renderVideoInto(container) {
        this._logger.info("Rendering video element into container", container);
        this._renderController.renderVideoInto(container);
    }
    setVolume(volume) {
        this._logger.info("Setting volume of the video element", {
            volume: volume
        });
        this._eventBus.publish((0, $de1faff85a9c2843$export$60e3c1025821af4f).SET_VOLUME, {
            volume: volume
        });
    }
    getState() {
        return this._state.getState();
    }
    destroy() {
        this._logger.info("Destroying");
        this._config = {
            ...(0, $a99bfb4a2e753607$export$1d295a4981f9ea1e).videoElementControllerConfig
        };
        this.detachVideoElementEvents();
        this._streamController.removeMediaStream();
        this._renderController.destroy();
        this._eventBus.publishSync((0, $de1faff85a9c2843$export$60e3c1025821af4f).DESTROY, {});
        this._logger.info("VideoElementController was destroyed");
        this._loggerTransport?.destroy();
    }
    reinit() {
        this._logger.info("Reinit requested");
        [
            this._autoplayController,
            this._customEventsEmitter,
            this._playbackController,
            this._streamController,
            this._stateController,
            this._timeUpdateController,
            this._renderController,
            this._eventsHandler
        ].forEach((inst)=>{
            if (inst) inst.init();
        });
        this.attachVideoElementEvents();
        this._logger.info("VideoElementController was reinited");
    }
    setLoggerLevels(levels, additionalScopes = [], ignoreDomains = []) {
        this._logger.info("Setting new log level", {
            levels: levels
        });
        if (this._loggerTransport) {
            this._loggerTransport.destroy();
            this._loggerTransport = null;
        }
        if (levels.length) this._loggerTransport = new (0, $6b88f92c0e0219d7$export$8734a8c908553955)(this._eventBus, levels, additionalScopes, ignoreDomains);
    }
    _syncConfig() {
        this._logger.verbose("Sycronizing configs across all controllers");
        this._autoplayController?.setConfig(this._config);
        this._eventsHandler.setConfig(this._config);
        this._streamController.setConfig(this._config);
        this._timeUpdateController.setConfig(this._config);
        this._renderController.setConfig(this._config);
        this._stateController.setConfig(this._config);
    }
    _createControllers() {
        this._logger.verbose("Creating all controllers");
        this._state = new (0, $442b7bba03edb347$export$4d5c8163a511d38a)((0, $55f31eac363b323e$export$36d128238e6b60f5));
        const propsWithState = {
            getVideoElement: this.getVideoElement,
            state: this._state,
            eventBus: this._eventBus
        };
        this._autoplayController = new (0, $13e0e8c55e207599$export$a9a0b55bc0093be5)(propsWithState);
        this._customEventsEmitter = new (0, $b8fa44c52cf48ebe$export$17bfd6b0f11e369b)(propsWithState);
        this._eventsHandler = new (0, $12f7c2f2c1b55bfc$export$3a521cb24f143cc8)(propsWithState);
        this._playbackController = new (0, $0e423be0c289d786$export$900e53962f1f4ab1)(propsWithState);
        this._streamController = new (0, $fa81a3aa7a22efa4$export$450c54b9e8861ae8)(propsWithState);
        this._stateController = new (0, $04304713e5d9da2c$export$9456d357203666ac)(propsWithState);
        this._timeUpdateController = new (0, $0b302ff0925c3ef2$export$25e21b090bbc69f9)(propsWithState);
        this._renderController = new (0, $bdd9a250938bedd7$export$61525c45d39f05de)(propsWithState);
        this._logger.verbose("Controllers created");
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $4ec065df5e9ead04$export$6dab3502ba426410.prototype, "addEventListener", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $4ec065df5e9ead04$export$6dab3502ba426410.prototype, "removeEventListener", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $4ec065df5e9ead04$export$6dab3502ba426410.prototype, "getIsPlaying", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $4ec065df5e9ead04$export$6dab3502ba426410.prototype, "getVideoElement", null);
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $4ec065df5e9ead04$export$6dab3502ba426410.prototype, "getCanvasElement", null);




var $2ef4272f3e810ecd$export$559043f40a876a16;
(function(ELogLevel) {
    ELogLevel[ELogLevel["FATAL"] = 0] = "FATAL";
    ELogLevel[ELogLevel["ERROR"] = 1] = "ERROR";
    ELogLevel[ELogLevel["WARN"] = 2] = "WARN";
    ELogLevel[ELogLevel["INFO"] = 3] = "INFO";
    ELogLevel[ELogLevel["DEBUG"] = 4] = "DEBUG";
    ELogLevel[ELogLevel["VERBOSE"] = 5] = "VERBOSE";
})($2ef4272f3e810ecd$export$559043f40a876a16 || ($2ef4272f3e810ecd$export$559043f40a876a16 = {}));
const $2ef4272f3e810ecd$export$3fe350146d2ec7e3 = {
    fatal: $2ef4272f3e810ecd$export$559043f40a876a16.FATAL,
    error: $2ef4272f3e810ecd$export$559043f40a876a16.ERROR,
    warn: $2ef4272f3e810ecd$export$559043f40a876a16.WARN,
    info: $2ef4272f3e810ecd$export$559043f40a876a16.INFO,
    debug: $2ef4272f3e810ecd$export$559043f40a876a16.DEBUG,
    verbose: $2ef4272f3e810ecd$export$559043f40a876a16.VERBOSE
};
const $2ef4272f3e810ecd$export$16884720e2f7a4b7 = (level)=>typeof level === "number" ? level : $2ef4272f3e810ecd$export$3fe350146d2ec7e3[level];
const $2ef4272f3e810ecd$export$2fd275ff363b1e1d = {
    [$2ef4272f3e810ecd$export$559043f40a876a16.FATAL]: "Fatal",
    [$2ef4272f3e810ecd$export$559043f40a876a16.WARN]: "Warning",
    [$2ef4272f3e810ecd$export$559043f40a876a16.ERROR]: "Error",
    [$2ef4272f3e810ecd$export$559043f40a876a16.INFO]: "Info",
    [$2ef4272f3e810ecd$export$559043f40a876a16.DEBUG]: "Debug",
    [$2ef4272f3e810ecd$export$559043f40a876a16.VERBOSE]: "Verbose"
};
const $2ef4272f3e810ecd$export$d9d573f04653e528 = [
    "verbose",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];






var $601fb94ec5611436$export$1f8aff248f4faedf;
(function(EUserMediaEvent) {
    EUserMediaEvent[EUserMediaEvent["MEDIA_DEVICES_UPDATED"] = 0] = "MEDIA_DEVICES_UPDATED";
})($601fb94ec5611436$export$1f8aff248f4faedf || ($601fb94ec5611436$export$1f8aff248f4faedf = {}));







const $ae09045410b72bdb$export$a1e39fde207e7783 = {
    H264: "H264/90000",
    VP8: "VP8/90000",
    VP9: "VP9/90000",
    OPUS: "opus/48000"
};
const $ae09045410b72bdb$var$RTP_PROFILE_MARKER = /a=rtpmap:\d+\s/;
const $ae09045410b72bdb$export$6072948b1c4e35dc = ({ sdp: sdp  })=>{
    if (!sdp) return [];
    const sdpLines = sdp.split(/\r?\n/);
    const codecsSdpLines = sdpLines.filter((sdpLine)=>sdpLine.match($ae09045410b72bdb$var$RTP_PROFILE_MARKER));
    return [
        ...new Set(codecsSdpLines.map((sdpLine)=>sdpLine.replace($ae09045410b72bdb$var$RTP_PROFILE_MARKER, "")))
    ];
};
const $ae09045410b72bdb$export$afa1bedd7937f947 = async (mode, codecs)=>{
    try {
        const direction = mode === "play" ? "recvonly" : "sendonly";
        const RTCPeerConnectionConstructor = (0, $78f9a8328618de05$export$4a938bfe709ed919)();
        const connection = new RTCPeerConnectionConstructor({
            iceServers: []
        });
        if (connection.addTransceiver) {
            connection.addTransceiver("audio", {
                direction: direction
            });
            connection.addTransceiver("video", {
                direction: direction
            });
        }
        const offerConfig = {};
        const sdp = await connection.createOffer(offerConfig);
        const sdpCodecs = $ae09045410b72bdb$export$6072948b1c4e35dc(sdp);
        connection.close();
        return codecs.filter((codec)=>sdpCodecs.includes(codec));
    } catch (e) {
        return [];
    }
};



const $78f9a8328618de05$export$4a938bfe709ed919 = ()=>{
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
};
const $78f9a8328618de05$export$7fb2a733b0757352 = ()=>{
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCIceCandidate;
};
const $78f9a8328618de05$export$f2fb4ef0cc8afad = ()=>{
    return window.RTCSessionDescription || // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.mozRTCSessionDescription || // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.webkitRTCSessionDescription;
};
const $78f9a8328618de05$export$54872e5d93ed468f = ()=>{
    const gUMRef = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices) || // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    navigator.getUserMedia && (0, $04a3ee20018aad1e$export$1d1d2ed6b55cf67f)(navigator.getUserMedia.bind(navigator)) || // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    navigator.webkitGetUserMedia && (0, $04a3ee20018aad1e$export$1d1d2ed6b55cf67f)(navigator.webkitGetUserMedia.bind(navigator)) || // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    navigator.mozGetUserMedia && (0, $04a3ee20018aad1e$export$1d1d2ed6b55cf67f)(navigator.mozGetUserMedia.bind(navigator));
    return (constraints)=>gUMRef.call(navigator, constraints);
};
const $78f9a8328618de05$export$eabd913148828152 = ()=>{
    return Boolean($78f9a8328618de05$export$4a938bfe709ed919() && $78f9a8328618de05$export$7fb2a733b0757352() && $78f9a8328618de05$export$f2fb4ef0cc8afad());
};
const $78f9a8328618de05$var$isH264PlayingSupported = async ()=>{
    const supportedCodecs = await (0, $ae09045410b72bdb$export$afa1bedd7937f947)("play", [
        (0, $ae09045410b72bdb$export$a1e39fde207e7783).H264,
        (0, $ae09045410b72bdb$export$a1e39fde207e7783).VP8
    ]);
    return supportedCodecs.some((codec)=>[
            (0, $ae09045410b72bdb$export$a1e39fde207e7783).H264,
            (0, $ae09045410b72bdb$export$a1e39fde207e7783).VP8
        ].includes(codec));
};
const $78f9a8328618de05$var$isH264BroadcastSupported = async ()=>{
    const supportedCodecs = await (0, $ae09045410b72bdb$export$afa1bedd7937f947)("broadcast", [
        (0, $ae09045410b72bdb$export$a1e39fde207e7783).H264,
        (0, $ae09045410b72bdb$export$a1e39fde207e7783).VP8
    ]);
    return supportedCodecs.some((codec)=>[
            (0, $ae09045410b72bdb$export$a1e39fde207e7783).H264,
            (0, $ae09045410b72bdb$export$a1e39fde207e7783).VP8
        ].includes(codec));
};
const $78f9a8328618de05$export$a6560a2ba6ceb992 = {
    getIsWebRTCApiSupported: $78f9a8328618de05$export$eabd913148828152,
    resolveGetUserMedia: $78f9a8328618de05$export$54872e5d93ed468f,
    resolveRTCPeerConnection: $78f9a8328618de05$export$4a938bfe709ed919,
    resolveRTCIceCandidate: $78f9a8328618de05$export$7fb2a733b0757352,
    resolveRTCSessionDescription: $78f9a8328618de05$export$f2fb4ef0cc8afad,
    isH264BroadcastSupported: $78f9a8328618de05$var$isH264BroadcastSupported,
    isH264PlayingSupported: $78f9a8328618de05$var$isH264PlayingSupported
};




const $10c197a6c5c4717f$export$556623c392d97c1d = (constraints)=>{
    if (!constraints) return false;
    if (typeof constraints === "boolean") return constraints;
    if (constraints.deviceId) {
        const deviceId = (0, $91039f54aac4c40b$export$545916e689f11822).safari ? constraints.deviceId : {
            exact: constraints.deviceId
        };
        return {
            deviceId: deviceId,
            channelCount: 2
        };
    }
    return false;
};



const $57282cf731ccecce$export$d702795962f48829 = (constraints, defaults)=>{
    if (!constraints) return false;
    if (typeof constraints === "boolean") return true;
    const aspectRatio = constraints.width && constraints.height ? Number(constraints.width) / Number(constraints.height) : defaults.baseAspectRatio;
    const config = {};
    if (constraints.frameRate) config.frameRate = {
        ideal: constraints.frameRate,
        min: 15
    };
    if (constraints.facingMode) {
        const supportedConstraints = navigator.mediaDevices.getSupportedConstraints();
        if (supportedConstraints.facingMode) config.facingMode = {
            exact: constraints.facingMode
        };
    }
    if (constraints.width) config.width = {
        ideal: constraints.width
    };
    if (constraints.height) config.height = {
        ideal: constraints.height
    };
    if (constraints.width && constraints.height && aspectRatio) config.aspectRatio = aspectRatio;
    if (constraints.deviceId) config.deviceId = (0, $91039f54aac4c40b$export$545916e689f11822).safari ? constraints.deviceId : {
        exact: constraints.deviceId
    };
    if (constraints.width && constraints.height && !config.facingMode) config.advanced = [
        {
            width: {
                min: constraints.width - defaults.sizeThreshold,
                max: constraints.width + defaults.sizeThreshold
            },
            height: {
                min: constraints.height - defaults.sizeThreshold,
                max: constraints.height + defaults.sizeThreshold
            }
        },
        {
            aspectRatio: aspectRatio
        }
    ];
    if (Object.keys(config).length === 0) return false;
    return config;
};


var $02c7c78eb295be97$export$896627ddf4278dec;
(function(EDeviceType) {
    EDeviceType["VIDEO_INPUT"] = "videoinput";
    EDeviceType["AUDIO_INPUT"] = "audioinput";
    EDeviceType["AUDIO_OUTPUT"] = "audiooutput";
})($02c7c78eb295be97$export$896627ddf4278dec || ($02c7c78eb295be97$export$896627ddf4278dec = {}));


const $2bc5b8308e82858b$var$filterDevicesByKind = (devices, kind)=>devices.filter((device)=>device.kind === kind);
const $2bc5b8308e82858b$export$e81743521636ab45 = async ()=>{
    const devices = await navigator.mediaDevices.enumerateDevices();
    return {
        audioInputs: $2bc5b8308e82858b$var$filterDevicesByKind(devices, (0, $02c7c78eb295be97$export$896627ddf4278dec).AUDIO_INPUT),
        audioOutputs: $2bc5b8308e82858b$var$filterDevicesByKind(devices, (0, $02c7c78eb295be97$export$896627ddf4278dec).AUDIO_OUTPUT),
        videoInputs: $2bc5b8308e82858b$var$filterDevicesByKind(devices, (0, $02c7c78eb295be97$export$896627ddf4278dec).VIDEO_INPUT)
    };
};



var $f324d632edb378be$export$45804e2b1c15d1b9;
(function(EMediaPermissionsErrorType) {
    EMediaPermissionsErrorType[/** (macOS) browser does not have permission to access cam/mic */ "SYSTEM_PERMISSION_DENIED"] = "SystemPermissionDenied";
    EMediaPermissionsErrorType[/** user denied permission for site to access cam/mic */ "USER_PERMISSION_DENIED"] = "UserPermissionDenied";
    EMediaPermissionsErrorType[/** (Windows) browser does not have permission to access cam/mic OR camera is in use by another application or browser tab */ "COULD_NOT_START_VIDEO_SOURCE"] = "CouldNotStartVideoSource";
    EMediaPermissionsErrorType[/** all other errors */ "GENERIC"] = "Generic";
})($f324d632edb378be$export$45804e2b1c15d1b9 || ($f324d632edb378be$export$45804e2b1c15d1b9 = {}));


const $595e3e11f68d4af7$export$af744cea0dcf0997 = async (constraints)=>new Promise((resolve, reject)=>{
        navigator.mediaDevices.getUserMedia(constraints ?? {
            audio: true,
            video: true
        }).then((stream)=>{
            stream.getTracks().forEach((track)=>{
                track.stop();
            });
            resolve(true);
        }).catch((err)=>{
            const errName = err.name;
            const errMessage = err.message;
            let errorType = (0, $f324d632edb378be$export$45804e2b1c15d1b9).GENERIC;
            if ((0, $91039f54aac4c40b$export$545916e689f11822).chrome) {
                if (errName === "NotAllowedError") {
                    if (errMessage === "Permission denied by system") errorType = (0, $f324d632edb378be$export$45804e2b1c15d1b9).SYSTEM_PERMISSION_DENIED;
                    else if (errMessage === "Permission denied") errorType = (0, $f324d632edb378be$export$45804e2b1c15d1b9).USER_PERMISSION_DENIED;
                } else if (errName === "NotReadableError") errorType = (0, $f324d632edb378be$export$45804e2b1c15d1b9).COULD_NOT_START_VIDEO_SOURCE;
            } else if ((0, $91039f54aac4c40b$export$545916e689f11822).safari) {
                if (errName === "NotAllowedError") errorType = (0, $f324d632edb378be$export$45804e2b1c15d1b9).USER_PERMISSION_DENIED;
            } else if ((0, $91039f54aac4c40b$export$545916e689f11822).edge) {
                if (errName === "NotAllowedError") errorType = (0, $f324d632edb378be$export$45804e2b1c15d1b9).USER_PERMISSION_DENIED;
                else if (errName === "NotReadableError") errorType = (0, $f324d632edb378be$export$45804e2b1c15d1b9).COULD_NOT_START_VIDEO_SOURCE;
            } else if ((0, $91039f54aac4c40b$export$545916e689f11822).firefox) {
                // https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia#exceptions
                if (errName === "NotFoundError") errorType = (0, $f324d632edb378be$export$45804e2b1c15d1b9).SYSTEM_PERMISSION_DENIED;
                else if (errName === "NotReadableError") errorType = (0, $f324d632edb378be$export$45804e2b1c15d1b9).SYSTEM_PERMISSION_DENIED;
                else if (errName === "NotAllowedError") errorType = (0, $f324d632edb378be$export$45804e2b1c15d1b9).USER_PERMISSION_DENIED;
                else if (errName === "AbortError") errorType = (0, $f324d632edb378be$export$45804e2b1c15d1b9).COULD_NOT_START_VIDEO_SOURCE;
            }
            reject({
                type: errorType,
                name: err.name,
                message: err.message
            });
        // Brave cannot be detected by the bowser library because they removed Brave from the User Agent to reduce fingerprinting
        // https://github.com/brave/browser-laptop/blob/master/CHANGELOG.md#090
        });
    });


var $a916f3a71400d332$export$15ca039425ab62e3;
(function(EMediaStreamTrackState) {
    EMediaStreamTrackState["LIVE"] = "live";
    EMediaStreamTrackState["ENDED"] = "ended";
})($a916f3a71400d332$export$15ca039425ab62e3 || ($a916f3a71400d332$export$15ca039425ab62e3 = {}));


const $8c70028ba4694b66$export$bf80e99f9d3910e7 = (track)=>{
    if (!track) return true;
    const { muted: muted , enabled: enabled , readyState: readyState  } = track;
    return muted || !enabled || readyState === (0, $a916f3a71400d332$export$15ca039425ab62e3).ENDED;
};


const $5dc3285cea160c4c$export$d8da4b867a2d26c9 = (stream)=>{
    if (!stream.active) return true;
    return stream.getTracks().every((0, $8c70028ba4694b66$export$bf80e99f9d3910e7));
};


const $7f8d387e5a5d24d2$export$e0818d0d44265f0f = (stream)=>{
    if (!stream) return;
    stream.getTracks().forEach((track)=>{
        track.stop();
        stream.removeTrack(track);
    });
    // @ts-ignore
    if (stream.stop) // @ts-ignore
    stream.stop();
    return;
};


class $bf3f4aeafb4efc61$export$187d60d76727d102 extends (0, $2698823e1558ee6a$export$493b9b82400bc18) {
    constructor(){
        super();
        this._currentMediaStream = null;
        this._mediaCheckCache = null;
        this._mediaDevices = null;
        this._eventBus = new (0, $ae21521d6337de01$export$5087227eb54526)();
        this._logger = (0, $59dc5ffc15ec8449$export$efa9a398d6368992)(this._eventBus, "UserMedia");
        this._loggerTransport = new (0, $6b88f92c0e0219d7$export$8734a8c908553955)(this._eventBus);
        this._logger.info("Created");
        navigator.mediaDevices.addEventListener("devicechange", this._onDevicesChanged);
    }
    destroy() {
        navigator.mediaDevices.removeEventListener("devicechange", this._onDevicesChanged);
        this._logger.info("Destroyed");
        this._stopCurrentStream();
    }
    async requestPermissions() {
        this._logger.info("Requesting permissions");
        if (this._mediaCheckCache) {
            this._logger.debug("Has previous check results cached. Returning it");
            this._logger.info("Check results", {
                ...this._mediaCheckCache
            });
            return this._mediaCheckCache;
        }
        try {
            this._logger.verbose("Request both video and audio permissions");
            await (0, $595e3e11f68d4af7$export$af744cea0dcf0997)({
                video: true,
                audio: true
            });
            this._logger.debug("No exceptions thrown while checking permissions. Saving both as available in cache");
            this._mediaCheckCache = {
                video: {
                    isAvailable: true,
                    error: null
                },
                audio: {
                    isAvailable: true,
                    error: null
                }
            };
            this._logger.info("Check results", {
                ...this._mediaCheckCache
            });
            return this._mediaCheckCache;
        } catch (e) {
            this._logger.debug("Got an exception while checking both audio and video permissions. Checking them individually", {
                exception: e.toString()
            });
            const checkResults = {
                video: {
                    isAvailable: false,
                    error: null
                },
                audio: {
                    isAvailable: false,
                    error: null
                }
            };
            checkResults.video = await this._checkKindPermissions({
                video: true,
                audio: false
            });
            this._logger.verbose(`Video permissions result: ${checkResults.video.isAvailable}`);
            checkResults.audio = await this._checkKindPermissions({
                video: false,
                audio: true
            });
            this._logger.verbose(`Audio permissions result: ${checkResults.audio.isAvailable}`);
            this._mediaCheckCache = checkResults;
            this._logger.debug(`Got individual check results`, {
                ...checkResults
            });
            this._logger.info("Check results", {
                ...this._mediaCheckCache
            });
            return this._mediaCheckCache;
        }
    }
    async getVideoDevices() {
        this._logger.info("Getting video devices list");
        const devices = await this._getMediaDevices();
        this._logger.info(`Got video devices`, devices);
        return devices.videoInputs;
    }
    async getAudioInputDevices() {
        this._logger.info("Getting audio input devices list");
        const devices = await this._getMediaDevices();
        this._logger.info("Got audio input devices", devices);
        return devices.audioInputs;
    }
    async getAudioOutputDevices() {
        this._logger.info("Getting audio output devices list");
        const devices = await this._getMediaDevices();
        this._logger.info("Got audio output devices", devices);
        return devices.audioOutputs;
    }
    async getMediaStream(constraints, defaults) {
        this._logger.info("Getting media stream", {
            constraints: constraints,
            defaults: defaults
        });
        const mappedConstraints = {};
        if (constraints.audio) {
            this._logger.debug("Audio constraints are specified in requested constraints. Mapping it");
            mappedConstraints.audio = (0, $10c197a6c5c4717f$export$556623c392d97c1d)(constraints.audio);
            this._logger.debug("Audio constraints mapped", {
                constraints: mappedConstraints.audio
            });
        }
        if (constraints.video) {
            this._logger.debug("Video constraints are specified in requested constraints. Mapping it");
            mappedConstraints.video = (0, $57282cf731ccecce$export$d702795962f48829)(constraints.video, defaults);
            this._logger.debug("Video constraints mapped", {
                constraints: mappedConstraints.video
            });
        }
        this._logger.info("Final constraints for media stream", {
            mappedConstraints: mappedConstraints
        });
        if (!this._currentMediaStream) {
            this._logger.debug("No current media stream known. Creating new stream");
            const mediaStream = await this._createNewStream(mappedConstraints);
            this._logger.info("Media stream is ready", {
                mediaStream: mediaStream
            });
            return mediaStream;
        }
        const isStreamActive = !(0, $5dc3285cea160c4c$export$d8da4b867a2d26c9)(this._currentMediaStream.stream);
        if (isStreamActive && await this._isCurrentStreamSatisfiesConstraints(mappedConstraints)) {
            this._logger.debug("Current stream is active and satisfies constraints. Returning cached one");
            this._logger.info("Media stream is ready", {
                mediaStream: this._currentMediaStream.stream
            });
            return this._currentMediaStream.stream;
        }
        this._logger.debug(`Current stream ${isStreamActive ? "does not satisfies constraints" : "is inactive"}. Creating new stream`);
        await this._stopCurrentStream();
        const mediaStream = await this._createNewStream(mappedConstraints);
        this._logger.info("Media stream is ready", {
            mediaStream: mediaStream
        });
        return mediaStream;
    }
    async _stopCurrentStream() {
        this._logger.debug("Stopping current media stream");
        if (!this._currentMediaStream) {
            this._logger.verbose("No current stream known. Skipping");
            return;
        }
        await (0, $7f8d387e5a5d24d2$export$e0818d0d44265f0f)(this._currentMediaStream.stream);
        this._currentMediaStream = null;
    }
    async _checkKindPermissions(constraints) {
        this._logger.debug("Checking kind permissions", {
            constraints: constraints
        });
        const checkResults = {
            isAvailable: false,
            error: null
        };
        try {
            this._logger.verbose("Requesting media permissions for constraints", {
                constraints: constraints
            });
            checkResults.isAvailable = await (0, $595e3e11f68d4af7$export$af744cea0dcf0997)(constraints);
            this._logger.verbose("Successfully got permissions for constraints", {
                constraints: constraints
            });
        } catch (e) {
            this._logger.verbose("Could not get permissions for constraints", {
                constraints: constraints,
                error: e
            });
            checkResults.isAvailable = false;
            checkResults.error = e;
        }
        this._logger.debug("Final result of permissions check", {
            constraints: constraints,
            checkResults: checkResults
        });
        return checkResults;
    }
    async _getMediaStream(constraints) {
        this._logger.debug("Getting media stream with constraints", {
            constraints: constraints
        });
        const getUserMedia = (0, $78f9a8328618de05$export$54872e5d93ed468f)();
        const stream = await getUserMedia(constraints);
        this._currentMediaStream = {
            constraints: constraints,
            stream: stream
        };
        this._logger.debug("Resulting media stream", {
            mediaStream: this._currentMediaStream.stream
        });
        return this._currentMediaStream.stream;
    }
    async _createNewStream(constraints) {
        this._logger.debug("Creating new media stream with constraints", {
            constraints: constraints
        });
        try {
            return await this._getMediaStream(constraints);
        } catch (error) {
            this._logger.warn(`Got an error while creating new media stream`, {
                error: error,
                constraints: constraints
            });
            if (error.name === "OverconstrainedError" && error.constraint === "deviceId") {
                this._logger.verbose("Trying to get stream with no audio deviceId specified");
                const newConstraints = {
                    ...constraints,
                    audio: true
                };
                return await this._getMediaStream(newConstraints);
            }
            throw error;
        }
    }
    async _getMediaDevices() {
        this._logger.verbose("Getting media devices");
        if (this._mediaDevices) {
            this._logger.verbose("Has media devices in cache, returning them", {
                devices: this._mediaDevices
            });
            return this._mediaDevices;
        }
        this._mediaDevices = await (0, $2bc5b8308e82858b$export$e81743521636ab45)();
        return this._mediaDevices;
    }
    async _isCurrentStreamSatisfiesConstraints(constraints) {
        this._logger.debug("Checking if current media stream satisfies constraints", {
            constraints: constraints,
            mediaStream: this._currentMediaStream
        });
        if (!this._currentMediaStream) {
            this._logger.verbose("No current media stream available");
            return false;
        }
        try {
            if (constraints.video) {
                this._logger.verbose("Checking video track constraints");
                const videoTrack = this._currentMediaStream.stream.getVideoTracks()[0];
                if (!videoTrack && constraints.video) {
                    this._logger.verbose("No video track in media stream and constraints has video");
                    return false;
                }
                if (videoTrack && !constraints.video) {
                    this._logger.verbose("There is video track in media stream and constraints has no video");
                    return false;
                }
                if (typeof constraints.video === "object" && constraints.video.deviceId && videoTrack.getCapabilities().deviceId !== constraints.video.deviceId) {
                    this._logger.verbose("Constraints has video device ID and it not matches current device id");
                    return false;
                }
                if (videoTrack && typeof constraints.video !== "boolean") {
                    this._logger.verbose("Trying to apply new constraints for video");
                    await videoTrack.applyConstraints(constraints.video);
                }
            }
        } catch (e) {
            this._logger.debug("Could not apply constraints or get capabilities of video track", {
                error: e
            });
            return false;
        }
        try {
            if (constraints.audio) {
                this._logger.verbose("Checking audio track constraints");
                const audioTrack = this._currentMediaStream.stream.getAudioTracks()[0];
                if (!audioTrack && constraints.audio) {
                    this._logger.verbose("No audio track in media stream and constraints has audio");
                    return false;
                }
                if (audioTrack && !constraints.audio) {
                    this._logger.verbose("There is audio track in media stream and constraints has no audio");
                    return false;
                }
                if (typeof constraints.audio === "object" && constraints.audio.deviceId && audioTrack.getCapabilities().deviceId !== constraints.audio.deviceId) {
                    this._logger.verbose("Constraints has audio device ID and it not matches current device id");
                    return false;
                }
                if (audioTrack && typeof constraints.audio !== "boolean") {
                    this._logger.verbose("Trying to apply new constraints for audio");
                    await audioTrack.applyConstraints(constraints.audio);
                }
            }
        } catch (e) {
            this._logger.debug("Could not apply constraints or get capabilities of audio track", {
                error: e
            });
            return false;
        }
        return true;
    }
    async _onDevicesChanged() {
        this._logger.debug("Media devices has changed");
        this._mediaDevices = null;
        const devices = await this._getMediaDevices();
        this._mediaDevices = devices;
        this.emitEvent((0, $601fb94ec5611436$export$1f8aff248f4faedf).MEDIA_DEVICES_UPDATED, devices);
    }
}
(0, $857b03fc78e933b4$export$29e00dfd3077644b)([
    (0, $5fb98e84471f1647$export$2385a24977818dd0)
], $bf3f4aeafb4efc61$export$187d60d76727d102.prototype, "_onDevicesChanged", null);





const $0146a1eaa10c0627$export$512e5252162de675 = ()=>window.MediaSource || window.WebKitMediaSource || window.ManagedMediaSource;
const $0146a1eaa10c0627$export$84aa8baebfe40cb3 = ()=>window.SourceBuffer || window.WebKitSourceBuffer || window.ManagedSourceBuffer;
const $0146a1eaa10c0627$export$aa9a42d7273bb011 = ()=>{
    const mediaSource = $0146a1eaa10c0627$export$512e5252162de675();
    if (!mediaSource) return false;
    const sourceBuffer = $0146a1eaa10c0627$export$84aa8baebfe40cb3();
    const isTypeSupported = typeof mediaSource.isTypeSupported === "function" && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
    const sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === "function" && typeof sourceBuffer.prototype.remove === "function";
    return isTypeSupported && sourceBufferValidAPI;
};
const $0146a1eaa10c0627$export$affafd53970e84fb = {
    isHLSSupported: $0146a1eaa10c0627$export$aa9a42d7273bb011
};




const $c879ea50b90f2822$export$deea386614a3c23c = (url)=>{
    if (!url) return {};
    try {
        const urlObj = new URL(url);
        const pathParts = urlObj.pathname.split("/");
        const streamId = pathParts[2];
        const fileName = pathParts[pathParts.length - 1];
        const resolution = fileName.match(/\d+_(\w+)/)?.[1] || "source";
        const isMaster = pathParts[3] === "master";
        return {
            streamId: streamId,
            resolution: resolution,
            isMaster: isMaster
        };
    } catch (e) {
        return {};
    }
};


const $e589e9090a88da35$export$53e796f17ca77411 = "<UTILS_VERSION>";




export {$8836d3b72d09aae5$export$5de0c2f48b03ac5c as EVideoControllerCustomEvent, $04d1fdac2b95d887$export$45a69314cf48a3eb as createConfig, $5fb98e84471f1647$export$2385a24977818dd0 as bind, $2b02fdf3c00e51bd$export$af29ccb356acd9fc as EPlaybackState, $2b02fdf3c00e51bd$export$41789205b2aea69e as EPlayerType, $2b02fdf3c00e51bd$export$fadb1eea8aff454b as EPlaybackStartType, $4ec065df5e9ead04$export$6dab3502ba426410 as VideoElementController, $48670755c01aa66a$export$7f7f07871384d60f as addMediaAction, $59dc5ffc15ec8449$export$efa9a398d6368992 as Logger, $2ef4272f3e810ecd$export$d9d573f04653e528 as logLevels, $2ef4272f3e810ecd$export$2fd275ff363b1e1d as LogLevelTitlesMap, $2ef4272f3e810ecd$export$16884720e2f7a4b7 as convertLogLevel, $2ef4272f3e810ecd$export$559043f40a876a16 as ELogLevel, $94461adbdb46cca1$export$7999b4a47f0af35e as ELoggerEvents, $6b88f92c0e0219d7$export$8734a8c908553955 as LoggerConsoleTransport, $ae21521d6337de01$export$5087227eb54526 as EventBus, $bf3f4aeafb4efc61$export$187d60d76727d102 as UserMedia, $442b7bba03edb347$export$4d5c8163a511d38a as StateManager, $601fb94ec5611436$export$1f8aff248f4faedf as EUserMediaEvent, $78f9a8328618de05$export$a6560a2ba6ceb992 as WebRTCCommonHelpers, $0146a1eaa10c0627$export$affafd53970e84fb as HLSCommon, $2698823e1558ee6a$export$493b9b82400bc18 as CustomEventTarget, $4053fea44be815ab$export$925cb066f75a1c3e as ObjectDeepDiff, $c879ea50b90f2822$export$deea386614a3c23c as parsePlaylistUrl, $e589e9090a88da35$export$53e796f17ca77411 as UTILS_VERSION};
//# sourceMappingURL=module.js.map
